/**
 * ChatBot
 *  シナリオの保存や、色の変更などを行う。
 */
import chatbot    from '@/api/chatbot'
import createUUID from '@/functions/createUUID'
import _, { set }          from 'lodash'

export default {
  namespaced: true,
  state: {
    menu: '',
    isSCNLoading: false,
    isCBLoading: true,
    isStartBotSet: 0,
    isNoStartScenerio: false,
    scenario: null,
    scenarioTemp: [],
    chatbotLogs: [],
    scenarioTable: [],
    copyScenarioTable: [],
    scenarioNameList: [],
    selectScenario: '',
    selectScenarioBotName: '',
    selectScenarioName : '',
    selectScenarioList: [],
    selectChatbot: {},
    selectStore: {},
    scenarioIndex: 0, // widget側、どのシナリオか保持しておくもの
    speaker: [],
    chatbot: {
      color: null,
      location: null,
      icon: null
    },
    chatbots: [],
    templateRobo: [],
    recommendBots: [],
    recommendBotsOther: [],
    botLeftAll: 0,
    isModalCreateScenario: false,
    isModalEditScenario: false,
    isModalDeleteScenario: false,
    isModalDeleteNode: false,
    isModalDeleteListScenario: false,
    isModalExportListScenario: false,
    isModalImportListScenario: false,
    isModalAllPartsConfirmListScenario: false,
    isUsedSort: false,
    isReplySort: false,
    isNameSort: false,
    isDefaultSort: false,
    isInstall: false,
    installHistory: [],
    rateHistory: [],
    modalScenario: {
      mainmessage: 'default',
      status: 0,
      select: [{
        message: 'default',
        text_option: 'default'
      }]
    },
    modalScenarioIndex: -1,
    stores: [],
    isDrop: false,
    scenarioPartsIndex: -1,
    dropTemplate: null,
    isConnecting: false,
    scenarioNodeData: [],
    nextNode: 0,
    pathScenario: null,
    isIconLoading: false,
    isSwitch: 0,
    chatbotStatus: {},
    roboPartsSet: [],
    selectTemplateId: '',
    isRoboPartsSetView: false,
    isLoadingScenarioKPI: false,
    isLoadingExportBot: false,
    isLoadingImportBot: false,
    scenarioKPI: [],
    detail: null,
    detailIsUp: false,
    bluePrintInfoFlg: false,
    bluePrintInfo: {
      width: 0,
      height: 0,
      scrollX: 0,
      scrollY: 0
    },
    stories: [],
    otherStories: [],
    story: null,
    scenes: [],
    storyDialog: [],
    characters: [],
    isStoryLoading: false,
    nextPubStory: [],
    isSavingStory: false,
    isGetPubStory: false,
    createDialogFlg: false,
    isExportLoading: false,
    isCompletedStory: false,
    isDelete: false,
    storyUserAction: {
      wantToMeet: [],
      finishReading: [],
      question: [],
      unread_zero: 0,
      unread_one: 0,
      unread_two: 0
    },
    storyProfileFavorite: [],
    storyQuizAnswers: [],
    isAutomatic: false,
    talkEnd: false,
    searchWordsBox: [],
    isClickTag: false,
    isClickId:-1,
    isClick: -1,
    chatbotminis: [],
    chatbotminivars: [],
    minipk: null,
    scenarioTitleBeforeChange: '',
    editAreaRatio: 0,
    chatbotHistory: [],
    scenarioHistory: [],
    chatbotUsedTimeHistory: [],
    scenarioHistoryAny: null,
    chatbottags: [],
    copyScenario: null,
    cutScenario: null,
    isEndPaste: false,
    isEndCutDelete: false,
    isCopy: false,
    isCut: false,
    isPaste: false,
    pasteX: 0,
    pasteY: 0,
    isDragScroll: true,
    isModalChatBotDetail: false,
    lastView: null,
    scenarioInportFlag: false,
    currentUndoIndex: 0,
    undoData: [],
    undoMax: 6,
    scenarioEditStats: [],
    isChangeName: false,
    roboPartsSet: [],
    selectRoboPartsSet: null,
    dropRoboPartsSet: null,
    isRoboPartsSetInside: false,
    roboPartsSetNextNode: '',
    roboPartsSetOutsideScenario: '',
    isConfirmByParts: false,
    isConfirmByStories: false,
    allStory: [],
    storyConfirm: [],
    confirmLoading: false,
    isModalSettingArguments: false,
},
  actions: {
    getChatBots ({commit}) {
      chatbot.getChatBot()
        .then((d) => {
          commit('CB_GET', JSON.parse(d.data))
        })
        .catch((e) => {
          alert('エラーが発生しました。')
        })
    },
    getChatBotOne ({commit}, data) {
      chatbot.getChatBotOne(data)
        .then((d) => {
          commit('CB_GET_ONE', JSON.parse(d.data))
        })
        .catch((e) => {
        })
    },
    getFromContentsChatBot ({commit}, data) {
      return chatbot.getFromContentsChatBot(data)
        .then((d) => {
          return d.data
        })
        .catch((e) => {
          return null
        })
    },
    getRecommendBot ({commit}, {cid, botid}) {
      commit('CB_GET_RMD', {cid, botid})
    },
    getChatBotStatus ({commit}, botid) {
      commit('CB_GET_STS', botid)
    },
    async createChatBot ({commit}, data) {
      return await chatbot.createChatBot(data)
        .then((d) => {
          commit('CB_CREATE', JSON.parse(d.data))
          return JSON.parse(d.data)
        })
        .catch((e) => {
          alert('エラーが発生しました。')
          return e
        })
    },
    deleteChatBot ({commit}, {companyid, chatbotID}) {
      commit('CB_DELETE', {companyid, chatbotID})
    },
    setChatBot ({commit}, data) {
      return chatbot.updateChatBot(data)
        .then((d) => {
          commit('CB_SET', d.data)
        })
        .catch((e) => {
          alert('エラーが発生しました。')
          commit('CB_SET_FAILURE')
        })
    },
    setChatBotsOrder ({commit}, chatbots) {
      commit('CB_SETS_ORD', chatbots)
    },
    createChatBotQuestionnaire ({commit}, data) {
      chatbot.createChatBotQuestionnaire(data)
    },
    setUndoScenario({commit}, {companyid, scenarioName}) {
      // 変更発生時Undo用データ保存
      commit('CB_SCN_SET_UNDO', {companyid, scenarioName})
    },
    undoScenario({commit}, {companyid, scenarioName}) {
      // Undo実施
      commit('CB_SCN_UNDO', {companyid, scenarioName})
    },
    redoScenario({commit}, {companyid, scenarioName}) {
      // Redo実施
      commit('CB_SCN_REDO', {companyid, scenarioName})
    },
    /* シナリオ保存 */
    saveScenario ({commit}, {companyid, scenarioName, data}) {
      return chatbot.saveScenario({data}, companyid, scenarioName)
        .then((d) => {
          commit('CB_SCN_SAVE', {companyid, scenarioName, d})
          return d.data
        })
        .catch((e) => {
          alert('すでに存在するシナリオです。')
        })
    },
    /* シナリオ保存(デモ用) */
    saveScenarioDemo ({commit}, data) {
      commit('CB_SCN_DEMO_SAVE', data)
    },
    /* シナリオ取得 */
    getScenario ({commit}, {companyid, scenarioName}) {
      commit('CB_SCN_GET', {companyid, scenarioName})
      commit('CB_SCN_NAME_GET', { companyid })
    },
    getScenarioList ({commit}, {companyid, scenarioName}) {
      return chatbot.getScenario(companyid, scenarioName)
        .then((d) => {
          return d
        })
        .catch((e) => {
          return []
        })
    },
    getTemplateScenarioList ({commit}, {companyid, scenarioName}) {
      return chatbot.getScenario(companyid, scenarioName)
        .then((d) => {
          return d
        })
        .catch((e) => {
          return []
        })
    },
    /* シナリオ取得(デモ用:一気に取得) */
    getScenarioDemo ({commit}, type) {
      commit('CB_SCN_DEMO', type)
    },
    /* シナリオ取得 - 一つだけ */
    getScenarioOne ({commit}, {companyid, scenarioName, node, rate, minipk}) {
      commit('CB_SCN_GET_ONE', {companyid, scenarioName, node, rate, minipk})
    },
    /* シナリオ取得 - 一つだけ - Temp */
    getScenarioOneTemp ({commit}, {companyid, scenarioName, node, rate, minipk}) {
      commit('CB_SCN_GET_ONE_T', {companyid, scenarioName, node, rate, minipk})
    },
    /* シナリオ削除 */
    deleteScenario ({commit}, {companyid, scenarioName, scenarioId, deleteIndex}) {
      commit('CB_SCN_DELETE', {companyid, scenarioName, scenarioId, deleteIndex})
    },
    /* シナリオ削除 */
    deleteScenarioDemo ({commit}, scenarioId) {
      commit('CB_SCN_DELETE_DEMO', scenarioId)
    },
    /* シナリオ全削除 */
    deleteScenarioList ({commit}, {companyid, scenarioName}) {
      commit('CB_SCN_DELETE_LIST', {companyid, scenarioName})
    },
    setImportScenarioFlag ({commit}, flag) {
      commit('CB_SCN_IMPORT_FLG', flag)
    },
    /* シナリオインポート */
    importScenarioList ({commit}, {scenarioName, scenarioTable}) {
      return chatbot.importScenarioList(scenarioName, scenarioTable)
        .then(() => {
          commit('CB_SCN_IMPORT_LIST')
          return
        })
        .catch((e) => {
          return
        })
    },
    /* シナリオテンプレート取得 */
    getScenarioTemplate ({commit}) {
      commit('CB_SCN_TMP_GET')
    },
    /* シナリオテンプレート 変更 [シナリオ追加] */
    saveScenarioTemplate ({commit}, scenario) {
      commit('CB_SCN_TMP_SAVE', scenario)
    },
    /* シナリオテンプレート 変更 [シナリオ変更] */
    updateScenarioTemplate ({commit},  data) {
      return chatbot.updateScenarioTemplate(data.selectTemplateId, data.scenarioTable)
        .then((d) => {
          commit('CB_SCN_TMP_SET', {data:d.data, scenario:data.scenario})
          if (data.notice) {
            alert('セーブしました！')
          }
        })
        .catch((e) => {
          commit('CB_SCN_TMP_SET_FAILURE')
          if (data.notice) {
            alert('エラーが発生いたしました。')
          }
        })
    },
    /* シナリオテンプレート　削除 */
    deleteScenarioTemplate ({commit}, beforenode) {
      commit('CB_SCN_TMP_DEL', beforenode)
    },
    /* シナリオテンプレート　全削除 */
    deleteScenarioListTemplate ({commit}) {
      commit('CB_SCN_TMP_DEL_LIST')
    },
    /* パーツセット ブループリント反映 */
    dispRoboPartsSetView ({commit}, roboPartsSet) {
      commit('DISP_ROBO_PARTS_SET_VIEW', roboPartsSet)
    },
    /* ロボテンプレート取得 */
    getTemplateRobo ({commit}) {
      return chatbot.getTemplateRobo()
        .then((d) => {
          commit('CB_TEMP_GET', d.data)
        })
        .catch((e) => {
          alert('エラーが発生しました。')
        })
    },
    /* シナリオ変更 */
    setScenario ({commit, state}, {companyid, scenarioName, scenario}) {
      if (scenario.status === 10) {
        scenario.mainmessage = scenario.mainmessage.replace(/&cnm;/g, ",")
      }
      return chatbot.updateScenario(scenario, companyid, scenarioName)
        .then(() => {
          return chatbot.getRoboPartsSet(companyid)
            .then((d) => {
              commit('GET_ROBO_PARTS_SET', JSON.parse(d.data))
              commit('CB_SCN_SET', {companyid, scenarioName, scenario})
              if (state.modalScenario.pk == scenario.pk) commit('CB_SEL_SCN', scenario)
              return
            })
            .catch((e) => {
              commit('CB_SCN_SET_ERROR')
              return
            })
          })
        .catch((e) => {
          commit('CB_SCN_SET_ERROR')
          return
        })
    },
    /* シナリオ変更 - Demo */
    setScenarioDemo ({commit}, scenario) {
      commit('CB_SCN_SET_DEMO', scenario)
    },
    /* シナリオ画像変更 */
    setScenarioImage ({commit}, data) {
      commit('CB_SCN_SET_IMG', data)
    },
    /* シナリオリスト保存 */
    saveScenarioList ({commit}, data) {
      return chatbot.saveScenarioList(data.scenarioTable, data.companyid, data.scenarioName)
        .then(() => {
          if (data.notice) {
            alert('セーブしました！')
          }
        })
        .catch((e) => {
          if (data.notice) {
            alert('エラーが発生いたしました。')
          }
        })
    },
    /* シナリオ名の保存 */
    saveScenarioName ({commit}, scenarioName) {
      commit('CB_SCN_SAVE_NAME', scenarioName)
    },
    /* シナリオ編集履歴の保存 */
    saveScenarioEditLog({commit}, {chatbot_id, time_sec}) {
      const data = {chatbot: chatbot_id, time_sec: Math.floor(time_sec)}
      return chatbot.saveScenarioEditLog(data)
        .catch((e) => {
          alert('エラーが発生いたしました。')
        })
    },
    /* シナリオ編集の統計情報取得 */
    getScenarioEditStats({commit}, data) {
      commit('CB_SCN_EDIT_STATS', [])
      return chatbot.getScenarioEditStats(data)
        .then((d) => {
          commit('CB_SCN_EDIT_STATS', d.data)
        })
        .catch((e) => {
          alert('エラーが発生いたしました。')
        })
    },
    /* パーツ全確定 */
    scenarioPartsConfirm ({commit}, data) {
      commit('SCN_PARTS_CONF_LOAD', true)
      return chatbot.scenarioPartsConfirm(data)
      .then(() => {
        commit('SCN_PARTS_CONF', data)
      })
      .catch((e) => {
        commit('SCN_PARTS_CONF_LOAD', false)
        alert('エラーが発生いたしました。')
      })
    },
    /* Mini PK のセット */
    setMiniPK ({commit}, pk) {
      commit('CB_MINI_SET', pk)
    },
    /** パーツセット取得 */
    getRoboPartsSet ({commit}, company_id) {
      chatbot.getRoboPartsSet(company_id)
        .then((d) => {
          commit('GET_ROBO_PARTS_SET', JSON.parse(d.data))
        })
        .catch(() => {
          alert('エラーが発生いたしました。')
        })
    },
    /** 新規パーツセット作成 */
    createRoboPartsSet ({commit}, roboPartsSet) {
      chatbot.createRoboPartsSet(roboPartsSet)
        .then((d) => {
          commit('CREATE_ROBO_PARTS_SET', JSON.parse(d.data))
        })
        .catch(() => {
          alert('エラーが発生いたしました。')
        })
    },
    /** パーツセット更新 */
    updateRoboPartsSet ({commit}, robo_parts_set) {
      chatbot.updateRoboPartsSet(robo_parts_set)
        .then(() => {
          commit('UPDATE_ROBO_PARTS_SET', robo_parts_set)
        })
        .catch(() => {
          alert('エラーが発生いたしました。')
        })
    },
    /** パーツセット削除 */
    deleteRoboPartsSet ({commit}, robo_parts_set) {
      chatbot.deleteRoboPartsSet(robo_parts_set.robo_parts_set_id)
        .then(() => {
          commit('DELETE_ROBO_PARTS_SET', robo_parts_set)
        })
        .catch(() => {
          alert('エラーが発生いたしました。')
        })
    },
    /** パーツセット入力設定 */
    setRoboPartsSetInputFlg ({commit}, flagData) {
      chatbot.setRoboPartsSetInputFlg(flagData)
        .then((d) => {
          commit('INPUT_ROBO_PARTS_SET', JSON.parse(d.data))
        })
        .catch((e) => {
          alert('エラーが発生いたしました。')
        })
    },
    /** パーツセット出力設定 */
    setRoboPartsSetOutputFlg ({commit}, flagData) {
      chatbot.setRoboPartsSetOutputFlg(flagData)
        .then((d) => {
          commit('OUTPUT_ROBO_PARTS_SET', JSON.parse(d.data))
        })
        .catch((e) => {
          alert('エラーが発生いたしました。')
        })
    },
    /** パーツセット内インプットbeforenode取得 */
    getRoboPartsSetInput ({commit}, robo_parts_set_id) {
      return chatbot.getRoboPartsSetInput(robo_parts_set_id)
        .then((d) => {
          return d.data
        })
        .catch((e) => {
          alert('エラーが発生いたしました。')
          return ''
        })
    },
    /** パーツセット進入時設定 */
    setRoboPartsSetInside ({commit}, {name, node}) {
      commit('SET_ROBO_PARTS_SET_INSIDE', {name, node})
    },
    /** パーツセット化モーダル表示 */
    changeModalExportRoboPartsSet ({commit}) {
      commit('EXPORT_ROBO_PARTS_SET')
    },
    /* シナリオのパーツセット化(エクスポート) */
    clickExportRoboPartsSet ({commit}, exportData) {
      chatbot.exportRoboPartsSet(exportData)
        .then((d) => {
          commit('CB_SCN_EXPORT_LIST', JSON.parse(d.data))
        })
        .catch((e) => {
          alert('エラーが発生いたしました。')
        })
    },
    /** シナリオ化モーダル表示 */
    changeModalImportRoboPartsSet ({commit}) {
      commit('CB_CHN_IMP_LIST')
    },
    /* パーツセットのシナリオ化(インポート) */
    importRoboPartsSet ({commit}, {scenarioName, roboPartsSet}) {
      return chatbot.importRoboPartsSet(scenarioName, roboPartsSet)
        .then(() => {
          commit('CB_SCN_IMPORT_LIST')
          return
        })
        .catch((e) => {
          return
        })
    },
    setChatLogs ({commit}, {message, speaker}) {
      commit('CB_CLG_SET', {message, speaker})
    },
    getScenarioName ({commit}, {companyid}) {
      commit('CB_SCN_NAME_GET', { companyid })
    },
    setScenarioIndex ({commit}, index) {
      commit('CB_SCN_IDX', index)
    },
    changeModalCreateScenario ({commit}) {
      commit('CB_CHN_CRE')
    },
    changeModalEditScenario ({commit}) {
      commit('CB_CHN_EDI')
    },
    changeModalDeleteScenario ({commit}) {
      commit('CB_CHN_DEL')
    },
    changeModalDeleteNode ({commit}, data) {
      commit('CB_NOD_DEL', data)
    },
    changeModalDeleteScenarioList ({commit}) {
      commit('CB_CHN_DEL_LIST')
    },
    changeModalAllPartsConfirmScenarioList ({commit}) {
      commit('CB_CHN_PAR_LIST')
    },
    changeModalAllFalse ({commit}) {
      commit('CB_CHN_ALL')
    },
    selectScenario ({commit}, scenario) {
      commit('CB_SEL_SCN', scenario)
    },
    selectDemoScenario ({commit}, beforenode) {
      commit('CB_DEMO_SEL_SCN', beforenode)
    },
    selectScenarioList ({commit}, {flg, scenario}) {
      commit('CB_SEL_SCN_LIST', {flg, scenario})
    },
    descriptionChange ({commit}, {scenario, description}) {
      commit('CB_SCN_DEP_CHG', {scenario, description})
    },
    randomSelectStore ({commit}, {category, type}) {
      commit('CB_RND_SEL', {category, type})
    },
    selectScenarioTable ({commit}, list) {
      commit('CB_SET_SCN', list)
    },
    closeModalScenario ({commit}) {
      commit('CB_CLS_MDL')
    },
    changeIsDrop ({commit}, index) {
      commit('CB_CHN_DRP', index)
    },
    changeIsDropList ({commit}, {index, roboPartsSet}) {
      commit('CB_CHN_DRP_LIST', {index, roboPartsSet})
    },
    changeIsConnecting ({commit}, {flg, scenario}) {
      commit('CB_CHN_CON', {flg, scenario})
    },
    saveNextNode ({commit}, index) {
      commit('CB_SET_IDX', index)
    },
    setPathScenario ({commit}, scenario) {
      commit('CB_SET_PATH_SCN', scenario)
    },
    setPasteFlg ({commit}, isPaste, isCopy, isCut) {
      commit('CB_SCN_SET_PASTE_FLG', isPaste, isCopy, isCut)
    },
    setPasteMenu ({commit}, {pasteX, pasteY}) {
      commit('CB_SCN_PASTE_MENU', {pasteX, pasteY})
    },
    scenarioCopy ({commit}) {
      commit('CB_SCN_COPY_INFO_CLR')
      commit('CB_SCN_COPY')
    },
    scenarioCut ({commit}) {
      commit('CB_SCN_COPY_INFO_CLR')
      commit('CB_SCN_CUT')
    },
    scenarioPaste ({commit}, companyid) {
      commit('CB_SCN_PASTE_SET')
      commit('CB_SCN_PASTE', companyid)
    },
    scenarioCutDelete ({commit}, companyid) {
      commit('CB_SCN_CUT_DEL', companyid)
    },
    scenarioCopyClear ({commit}) {
      commit('CB_SCN_COPY_INFO_CLR')
    },
    scenarioPastCancel ({commit}) {
      commit('CB_SCN_COPY_INFO_CLR')
    },
    scenarioDuplicate ({commit}, companyid) {
      commit('CB_SCN_COPY_INFO_CLR')
      commit('CB_SCN_DUP_SET')
      commit('CB_SCN_PASTE', companyid)
    },
    setStartFlgSet ({commit}, companyid) {
      commit('CB_INT_SET_FLG', companyid)
    },
    async updateScenario ({commit}, data) {
      await chatbot.updateScenario(data.scenario, data.companyid, data.scenario.name)
    },
    updateScenarioTable ({commit}, data) {
      commit('UPDATE_SCENARIO_TABLE', data)
    },
    async setChatBotIcon ({commit}, {name, id, image_id}) {
      commit('SET_CB_ICON_LOADING', true)
      return await chatbot.updateChatBotIcon(name, id, image_id)
        .then((d) => {
          commit('SET_CB_ICON', JSON.parse(d.data))
          commit('SET_CB_ICON_LOADING', false)
          return d.data.icon_data
        })
        .catch((e) => {
          commit('SET_CB_ICON_LOADING', false)
          return null
        })
    },
    sortChatbots ({commit}, type) {
      commit('SORT_CB', type)
    },
    selectChatbot ({commit}, chatbot) {
      commit('CB_SEL', chatbot)
    },
    selectTemplate ({commit}, selected) {
      commit('CB_SEL_TEMP', selected)
    },
    copyScenarioTable ({commit}) {
      commit('CB_CPY_TEMP')
    },
    sortScenarioList ({commit}, data) {
      chatbot.sortScenarioList(data)
    },
    getChatBotStoreItem ({commit}) {
      chatbot.getChatBotStoreItem()
        .then((d) => {
          commit('CB_STR_ITEM_GET', d.data)
        })
        .catch((e) => {
          alert('エラーが発生いたしました。')
        })
    },
    createChatBotStoreItem ({commit}, data) {
      chatbot.createChatBotStoreItem(data)
        .then(() => {
          alert('ロボをテンプレート化しました。')
        })
        .catch((e) => {
          alert('エラーが発生いたしました。')
        })
    },
    updateChatBotStoreItem ({commit}, data) {
      commit('CB_STR_ITEM_EDI', data)
    },
    deleteChatBotStoreItem ({commit}, {chatbotID}) {
      chatbot.deleteChatBotStoreItem(chatbotID)
        .then(() => {
          commit('CB_STR_ITEM_DEL', {chatbotID})
        })
        .catch((e) => {
          alert('エラーが発生いたしました。')
        })
    },
    installChatBot ({commit}, data) {
      commit('CB_STR_ITEM_INSTL', data)
    },
    createChatBotStoreHistory ({commit}, bot) {
      commit('CB_STR_HIST_CRE', bot)
    },
    createChatBotStoreRate ({commit}, rate) {
      commit('CB_STR_RATE_CRE', rate)
    },
    editChatBotStoreRate ({commit}, rate) {
      commit('CB_STR_HIST_EDI', rate)
    },
    getChatBotStoreRate ({commit}) {
      commit('CB_STR_RATE_GET')
    },
    getChatBotStoreHistory ({commit}) {
      commit('CB_STR_HIST_GET')
    },
    sendEmailScenario ({commit}, data) {
      commit('CB_SCN_SEND', data)
    },
    sendSMSScenario ({commit}, data) {
      chatbot.sendSMSScenario(data)
    },
    chatbotChangeScenario ({commit}, scenario) {
      commit('CB_CHG_SCN', scenario)
    },
    getScenarioKPI ({commit}, name) {
      commit('GET_SCN_KPI', name)
    },
    detail ({commit}, {msg, isUp}) {
      commit('DETAIL', {msg, isUp})
    },
    exportBot ({commit}, {company_id, id}) {
      commit('CB_EXPORT', {company_id, id})
    },
    importBot ({commit}, file) {
      commit('CB_IMPORT', file)
    },
    sendReminderEmail ({commit}, {id, param}) {
      commit('CB_SEND_RMD', {id, param})
    },
    /* ブループリント更新フラグ */
    setBluePrintInfoFlg({commit}, param){
      commit('SET_BP_INFO_FLG', param)
    },
    /* ブループリント情報更新 */
    setBluePrintInfo({commit}, {width,height,scrollX,scrollY}) {
      commit('SET_BP_INFO', {width,height,scrollX,scrollY})
    },
    /* 動画ファイルアップロード */
    uploadMovieFile({commit},{scenario, data, template_id}) {
      commit('UL_MOVIE_FILE',{scenario, data, template_id})
    },
    /* ファイルアップロード(ダウンロードパーツ) */
    uploadAttachmentFile ({commit}, {scenario_pk, data}) {
      commit('UL_DL_FILE', {scenario_pk, data})
    },
    getStory({commit}) {
      commit('ST_LOADING', true)
      chatbot.getStory('')
        .then((d) => {
          commit('ST_GET', JSON.parse(d.data))
          commit('ST_LOADING', false)
        })
        .catch((e) => {
          alert('エラーが発生いたしました。')
        })
    },
    getPubStory({commit}, {cid, id}) {
      commit('ST_LOADING', true)
      chatbot.getPubStory(cid, id)
        .then((d) => {
          commit('ST_PUB_GET', d.data)
        })
        .catch((e) => {
          alert('該当のページが見つかりませんでした。本ノベルは削除されているか、URLが誤っている可能性があります。URLをご確認の上アクセスのほど宜しくお願い致します。')
          location.href = '/404?cid=' + cid
        })
    },
    loadingEnd ({commit}) {
      commit('ST_LOADING', false)
    },
    setStory({commit}, id) {
      chatbot.getStory(id)
        .then((d) => {
          commit('ST_SET', JSON.parse(d.data))
        })
        .catch((e) => {
          alert('エラーが発生いたしました。')
        })
    },
    createStory({commit}, data) {
      chatbot.createStory(data)
        .then((d) => {
          commit('ST_CREATE', JSON.parse(d.data))
        })
    },
    readComment({commit},data) {
      return chatbot.readComment(data)
        .then((d) => {
        })
      　.catch((e) => {
          alert('エラーが発生いたしました。')
      　 })
    },
    updateStory({commit}, data) {
      commit('ST_SAVING', true)
      chatbot.updateStory(data)
        .then((d) => {
          commit('ST_UPDATE', JSON.parse(d.data))
          commit('ST_SAVING', false)
        })
        .catch((e) => {
          alert('エラーが発生いたしました。')
          commit('ST_SAVING', false)
        })
    },
    deleteStory({commit}, id) {
      commit('ST_SAVING', true)
      chatbot.deleteStory(id)
        .then((d) => {
          commit('ST_DELETE', id)
          commit('ST_SAVING', false)
        })
        .catch((e) => {
          alert('エラーが発生いたしました。')
          commit('ST_SAVING', false)
        })
    },
    getScene({commit}, id) {
      chatbot.getScene(id)
        .then((d) => {
          commit('ST_SCN_GET', JSON.parse(d.data))
        })
        .catch((e) => {
          alert('エラーが発生いたしました。')
        })
    },
    createScene({commit}, data) {
      commit('ST_SAVING', true)
      chatbot.createScene(data)
        .then((d) => {
          commit('ST_SCN_CREATE', JSON.parse(d.data))
          commit('ST_SAVING', false)
        })
        .catch((e) => {
          alert('エラーが発生いたしました。')
          commit('ST_SAVING', false)
        })
    },
    updateScene({commit}, data) {
      commit('ST_SAVING', true)
      chatbot.updateScene(data)
        .then((d) => {
          commit('ST_SCN_UPDATE', JSON.parse(d.data))
          commit('ST_SAVING', false)
        })
        .catch((e) => {
          alert('エラーが発生いたしました。')
          commit('ST_SAVING', false)
        })
    },
    deleteScene({commit}, id) {
      commit('ST_SAVING', true)
      chatbot.deleteScene(id)
        .then((d) => {
          commit('ST_SCN_DELETE', id)
          commit('ST_SAVING', false)
        })
        .catch((e) => {
          alert('エラーが発生いたしました。')
          commit('ST_SAVING', false)
        })
    },
    getCharacter({commit}, id) {
      chatbot.getCharacter(id)
        .then((d) => {
          commit('ST_CHR_GET', JSON.parse(d.data))
        })
        .catch((e) => {
          alert('エラーが発生いたしました。')
        })
    },
    createCharacter({commit}, data) {
      commit('ST_SAVING', true)
      chatbot.createCharacter(data)
        .then((d) => {
          commit('ST_CHR_CREATE', JSON.parse(d.data))
          commit('ST_SAVING', false)
        })
        .catch((e) => {
          alert('エラーが発生いたしました。')
          commit('ST_SAVING', false)
        })
    },
    updateCharacter({commit}, data) {
      commit('ST_SAVING', true)
      chatbot.updateCharacter(data)
        .then((d) => {
          commit('ST_CHR_UPDATE', JSON.parse(d.data))
          commit('ST_SAVING', false)
        })
        .catch((e) => {
          alert('エラーが発生いたしました。')
          commit('ST_SAVING', false)
        })
    },
    deleteCharacter({commit}, id) {
      commit('ST_SAVING', true)
      chatbot.deleteCharacter(id)
        .then((d) => {
          commit('ST_CHR_DELETE', id)
          commit('ST_SAVING', false)
        })
        .catch((e) => {
          alert('エラーが発生いたしました。')
          commit('ST_SAVING', false)
        })
    },
    getDialog({commit}, id) {
      chatbot.getDialog(id)
        .then((d) => {
          commit('ST_DLG_GET', JSON.parse(d.data))
        })
        .catch((e) => {
          alert('エラーが発生いたしました。')
        })
    },
    createDialog({commit}, data) {
      commit('ST_SAVING', true)
      chatbot.createDialog(data)
        .then((d) => {
          commit('ST_DLG_CREATE', JSON.parse(d.data))
          commit('ST_SAVING', false)
        })
        .catch((e) => {
          alert('エラーが発生いたしました。')
          commit('ST_SAVING', false)
        })
    },
    createIDXDialog ({commit}, data) {
      commit('ST_SAVING', true)
      chatbot.createDialog(data)
        .then((d) => {
          commit('ST_DLG_IDX_CREATE', JSON.parse(d.data))
          commit('ST_SAVING', false)
        })
        .catch((e) => {
          alert('エラーが発生いたしました。')
          commit('ST_SAVING', false)
        })
    },
    updateDialog({commit}, data) {
      commit('ST_SAVING', true)
      chatbot.updateDialog(data)
        .then((d) => {
          commit('ST_DLG_UPDATE', JSON.parse(d.data))
          commit('ST_SAVING', false)
        })
        .catch((e) => {
          alert('エラーが発生いたしました。')
          commit('ST_SAVING', false)
        })
    },
    deleteDialog({commit}, id) {
      commit('ST_SAVING', true)
      chatbot.deleteDialog(id)
        .then((d) => {
          commit('ST_DLG_DELETE', id)
          commit('ST_SAVING', false)
        })
        .catch((e) => {
          alert('エラーが発生いたしました。')
          commit('ST_SAVING', false)
        })
    },
    importStoryView({commit}, data) {
      chatbot.importStoryView(data)
        .then((d) => {
          alert('インポートが完了いたしました。再読み込みいたします。')
          location.reload()
        })
        .catch((e) => {
          alert('エラーが発生いたしました。')
        })
    },
    exportStoryView({commit}, id) {
      commit('ST_EXPORTING', true)
      chatbot.exportStoryView(id)
        .then((d) => {
          var element = document.createElement('a')
          element.setAttribute('href', 'data:text/plain;charset=utf-8,' + encodeURIComponent(d.data.text))
          element.setAttribute('download', d.data.name + '.txt')
          element.style.display = 'none'
          document.body.appendChild(element)
          element.click()
          document.body.removeChild(element)
          commit('ST_EXPORTING', false)
        })
        .catch((e) => {
          alert('エラーが発生いたしました。')
        })
    },
    getNextPubStory ({commit}, id) {
      commit('ST_PUB_NEXT_LOADING')
      chatbot.getNextPubStory(id)
        .then((d) => {
          commit('ST_PUB_NEXT', JSON.parse(d.data))
        })
        .catch((e) => {
          alert('エラーが発生いたしました。')
        })
    },
    createPVStory ({commit}, data) {
      chatbot.createPVStory(data)
        .then((d) => {
        })
        .catch((e) => {
          alert('エラーが発生いたしました。')
        })
    },
    createGVStory ({commit}, data) {
      chatbot.createGVStory(data)
        .then((d) => {
        })
        .catch((e) => {
          alert('エラーが発生いたしました。')
        })
    },
    getPVStory ({commit}, id) {
      chatbot.getPVStory(id)
        .then((d) => {
        })
        .catch((e) => {
          alert('エラーが発生いたしました。')
        })
    },
    getGVStory ({commit}, id) {
      chatbot.getGVStory(id)
        .then((d) => {
        })
        .catch((e) => {
          alert('エラーが発生いたしました。')
        })
    },
    updatePVStory ({commit}, data) {
      chatbot.updatePVStory(data)
        .then((d) => {
        })
        .catch((e) => {
          alert('エラーが発生いたしました。')
        })
    },
    updateGVStory ({commit}, data) {
      chatbot.updateGVStory(data)
        .then((d) => {
        })
        .catch((e) => {
          alert('エラーが発生いたしました。')
        })
    },
    deletePVStory ({commit}, id) {
      chatbot.deletePVStory(id)
        .then((d) => {
        })
        .catch((e) => {
          alert('エラーが発生いたしました。')
        })
    },
    deleteGVStory ({commit}, id) {
      chatbot.deleteGVStory(id)
        .then((d) => {
        })
        .catch((e) => {
          alert('エラーが発生いたしました。')
        })
    },
    copyStory ({commit}, {data, idx}) {
      chatbot.copyStory(data)
        .then((d) => {
          commit('ST_COPY', {data: JSON.parse(d.data), idx})
        })
        .catch((e) => {
          alert('エラーが発生いたしました。')
        })
    },
    registerMovieDialog ({ commit }, data) {
      chatbot.registerMovieDialog(data)
        .then((d) => {
          commit('REGISTER_MOVIE_DIALOG', {data: JSON.parse(d.data)})
        })
        .catch((e) => {
          alert('エラーが発生いたしました。')
        })
    },
    storyUserAction ({ commit }, data) {
      chatbot.storyUserAction(data)
        .then((d) => {
        })
        .catch((e) => {
          alert('エラーが発生いたしました。')
        })
    },
    getStoryUserAction ({ commit }, id) {
      chatbot.getStoryUserAction(id)
        .then((d) => {
          commit('GET_STORY_USER_ACTION', d.data)
        })
        .catch((e) => {
          alert('エラーが発生いたしました。')
        })
    },
    replyEmail({ commit }, data) {
      return chatbot.replyEmail(data)
        .then((d) => {
          if (d.data == '送信完了') {
            alert('送信しました。')
          }
        })
        .catch((e) => {
          alert('エラーが発生いたしました。')
        })
    },
    postStoryProfileFavorite ({ commit }, data) {
      chatbot.postStoryProfileFavorite(data)
        .then((d) => {
          if (d.data == -1) {
            alert('既に登録済みです')
          } else {
            alert('保存しました。')
          }
        })
        .catch((e) => {
          alert('エラーが発生いたしました。')
        })
    },
    getStoryProfileFavorite  ({ commit }) {
      chatbot.getStoryProfileFavorite()
        .then((d) => {
          commit('GET_STORY_PROFILE_FAVORITE', d.data)
        })
        .catch((e) => {
          alert('エラーが発生いたしました。')
        })
    },
    getStoryQuizAnswer ({commit}, id) {
      chatbot.getStoryQuizAnswer(id)
        .then((d) => {
          commit('SET_QUIZ_ANSWER', d.data)
        })
        .catch((e) => {
          alert('エラーが発生いたしました。')
        })
    },
    registerStoryQuizAnswer ({commit}, data) {
      chatbot.registerStoryQuizAnswer(data)
        .catch((e) => {
          alert('エラーが発生いたしました。')
        })
    },
    clickAutoBtn({ commit }, payload) {
      commit('CLICK_AUTO_BTN', payload)
    },
    mountChatPage({ commit }) {
      commit('MOUNT_CHATPAGE')
    },
    clearStory({ commit }) {
      commit('CLEAR_STORY')
    },
    clearStoryDialog({ commit }) {
      commit('CLEAR_STORY_DIALOG')
    },
    updateOrderChatbot ({ commit }, data) {
      chatbot.updateOrderChatbot(data)
        .catch((e) => {
          alert('エラーが発生いたしました。')
        })
    },
    updateOrderStory ({ commit }, data) {
      chatbot.updateOrderStory(data)
        .catch((e) => {
          alert('エラーが発生いたしました。')
        })
    },
    isClickTag({commit}, {flg,id,tagList}) {
      commit('IS_CLICK_TAG', {flg,id,tagList})
    },
    searchWordsInitial({ commit }, { tag, tagList }) {
      commit('SEARCH_WORDS_INITIAL', {tag,tagList})
    },
    // ChatBotMini API
    async createChatBotMini({commit}, data) {
      return await chatbot.createChatBotMini(data)
        .then((d) => {
          commit('CB_MN_CREATE', JSON.parse(d.data))
          return(JSON.parse(d.data))
        })
        .catch((e) => {
          alert('エラーが発生いたしました。')
        })
    },
    getChatBotMini({commit}, id) {
      chatbot.getChatBotMini(id)
        .then((d) => {
          commit('CB_MN_GET', JSON.parse(d.data))
        })
        .catch((e) => {
          alert('エラーが発生いたしました。')
        })
    },
    setChatBotMini({commit}, data) {
      commit('CB_MN_SET', data)
    },
    updateChatBotMiniLock ({commit}, data) {
      chatbot.updateChatBotMini(data)
        .then((d) => {
          commit('CB_MN_UPDATE', JSON.parse(d.data))
        })
        .catch((e) => {
          alert('エラーが発生いたしました。')
        })
    },
    updateChatBotMini({commit}, data) {
      chatbot.updateChatBotMini(data)
        .then((d) => {
          commit('CB_MN_UPDATE', JSON.parse(d.data))
        })
        .catch((e) => {
          alert('エラーが発生いたしました。')
        })
    },
    deleteChatBotMini({commit}, id) {
      chatbot.deleteChatBotMini(id)
        .then((d) => {
          commit('CB_MN_DELETE', id)
          alert('削除しました。')
        })
        .catch((e) => {
          alert('エラーが発生いたしました。')
        })
    },
    // ChatBotMiniVariableGroup API
    createChatBotMiniVariableGroup({commit}, data) {
      return chatbot.createChatBotMiniVariableGroup(data)
        .then((d) => {
          commit('CB_MNVG_CREATE', JSON.parse(d.data))
          return(JSON.parse(d.data))
        })
        .catch((e) => {
          alert('エラーが発生いたしました。')
        })
    },
    getChatBotMiniVariableGroup({commit}, id) {
      chatbot.getChatBotMiniVariableGroup(id)
        .then((d) => {
          commit('CB_MNVG_GET', JSON.parse(d.data))
        })
        .catch((e) => {
          alert('エラーが発生いたしました。')
        })
    },
    updateChatBotMiniVariableGroup({commit}, data) {
      chatbot.updateChatBotMiniVariableGroup(data)
        .then((d) => {
          commit('CB_MNVG_UPDATE', JSON.parse(d.data))
        })
        .catch((e) => {
          alert('エラーが発生いたしました。')
        })
    },
    deleteChatBotMiniVariableGroup({commit}, pk) {
      return chatbot.deleteChatBotMiniVariableGroup(pk)
        .then((d) => {
          commit('CB_MNVG_DELETE', pk)
          alert('削除いたしました。')
          return d.data
        })
        .catch((e) => {
          alert('エラーが発生いたしました。')
        })
    },
    setScenarioTitleBeforeChange ({commit}, payload) {
      commit('SET_SCENARIO_TITLE_BEFORE_CHANGE', payload)
    },
    getEditAreaRatio ({commit}) {
      commit('GET_EDIT_AREA_RATIO')
    },
    // ChatBotHistory API
    createChatBotHistory ({commit}, data) {
      chatbot.createChatBotHistory(data)
        .then((d) => {
          commit('CB_HIS_CREATE', d.data)
        })
        .catch((e) => {
          alert('エラーが発生いたしました。')
        })
    },
    getChatBotHistory ({commit}, id) {
      chatbot.getChatBotHistory(id)
        .then((d) => {
          commit('CB_HIS_GET', d.data)
        })
        .catch((e) => {
          alert('エラーが発生いたしました。')
        })
    },
    // ScenarioHistory API
    createScenarioHistoryAny ({commit}, data) {
      return chatbot.createScenarioHistoryAny(data)
        .then((d) => {
          commit('CREATE_SCN_HIS', JSON.parse(d.data))
          return d.data
        })
    },
    updateScenarioHistoryAny ({commit}, data) {
      return chatbot.updateScenarioHistoryAny(data)
        .then((d) => {
          return JSON.parse(d.data)
        })
    },
    getScenarioHistory ({commit}, id) {
      chatbot.getScenarioHistory(id)
        .then((d) => {
          commit('SCN_HIS_GET', d.data)
        })
        .catch((e) => {
          alert('エラーが発生いたしました。')
        })
    },
    // ChatBotUsedTimeHistory API
    createChatBotUsedTimeHistoryAny ({commit}, data) {
      chatbot.createScenarioHistoryAny(data)
    },
    getChatBotUsedTimeHistory ({commit}, id) {
      chatbot.getChatBotUsedTimeHistory(id)
        .then((d) => {
          commit('CBUT_HIS_GET', d.data)
        })
        .catch((e) => {
          alert('エラーが発生いたしました。')
        })
    },
    // ChatBotTag API
    createChatBotTag({commit}, data) {
      return chatbot.createChatBotTag(data)
        .then((d) => {
          commit('CB_TAG_CREATE', d.data)
          return d.data
        })
        .catch((e) => {
          alert('エラーが発生いたしました。')
          return
        })
    },
    getChatBotTag({commit}, id) {
      chatbot.getChatBotTag(id)
        .then((d) => {
          commit('CB_TAG_GET', d.data)
        })
        .catch((e) => {
          alert('エラーが発生いたしました。')
        })
    },
    updateChatBotTag({commit}, data) {
      chatbot.updateChatBotTag(data)
        .then((d) => {
          commit('CB_TAG_UPDATE', d.data)
        })
        .catch((e) => {
          alert('エラーが発生いたしました。')
        })
    },
    deleteChatBotTag ({commit}, id) {
      chatbot.deleteChatBotTag(id)
        .then((d) => {
          commit('CB_TAG_DELETE', id)
          alert('削除しました。')
        })
        .catch((e) => {
          console.error(e)
          alert('エラーが発生いたしました。')
        })
    },
    exportChatBotTag({commit}) {
      return chatbot.exportChatBotTag()
        .then((d) => {
          return d.data
        })
        .catch((e) => {
          console.error(e)
          alert('エクスポートに失敗いたしました。\nしばらくしてからのアクセスをお願いいたします。')
          return
        })
    },
    bulkCreateChatbotTag ({commit}, data) {
      return chatbot.bulkCreateChatbotTag(data)
        .then((d) => {
          commit('CB_TAG_GET', JSON.parse(d.data))
          return
        })
        .catch((e) => {
          console.error(e)
          alert('エラーが発生いたしました。')
          return
        })
    },
    getChatbotRegularSendingContent ({commit}, {bot_id, media_type}) {
      /**
       * ロボ定期送付の送信内容を取得
       * @param {String} bot_id - ロボID
       * @param {String} media_type - 送信タイプ "Email" or "SMS"
       * @return {Object} result
       * @return {String} result.title - 送信タイトル
       * @return {String} result.body - 送信本文
       */
      return chatbot.getChatbotRegularSendingContent(bot_id, media_type)
        .then((d) => {
          return JSON.parse(d.data)
        })
        .catch((e) => {
          alert('エラーが発生いたしました。')
        })
    },
    setChatbotRegularSendingContent ({commit}, data) {
      /**
       * ロボ定期送付の送信内容を設定
       * @param {Object} data
       * @param {String} data.chatbot - ロボID
       * @param {String} data.media_type - 送信タイプ "Email" or "SMS"
       * @param {String} data.title - 送信タイトル
       * @param {String} data.body - 送信本文
       */
      return chatbot.setChatbotRegularSendingContent(data)
        .catch((e) => {
          alert('エラーが発生いたしました。')
        })
    },
    chatBotRegularSendingPeriod ({commit}, data) {
      return chatbot.chatBotRegularSendingPeriod(data)
        .then((d) => {
          alert('登録しました')
        })
        .catch((e) => {
          alert('エラーが発生いたしました。')
        })
    },
    fetchChatBotRegularSendingPeriod ({commit}, {bot_id, media_type}) {
      return chatbot.fetchChatBotRegularSendingPeriod(bot_id, media_type)
        .then((d) => {
          return d.data
        })
        .catch((e) => {
          alert('エラーが発生いたしました。')
        })
    },
    deleteChatBotRegularSendingPeriod ({commit}, {bot_id, pk}) {
      return chatbot.deleteChatBotRegularSendingPeriod(bot_id, pk)
        .then((d) => {
          return d.data
        })
        .catch((e) => {
          alert('エラーが発生いたしました。')
        })
    },
    chatBotRegularSending ({commit}, data) {
      return chatbot.chatBotRegularSending(data)
        .then((d) => {
        })
        .catch((e) => {
          alert('エラーが発生いたしました。')
        })
    },
    fetchChatBotRegularSending ({commit}, {bot_id, media_type}) {
      return chatbot.fetchChatBotRegularSending(bot_id, media_type)
        .then((d) => {
          return d.data
        })
        .catch((e) => {
          alert('エラーが発生いたしました。')
        })
    },
    deleteChatBotRegularSending ({commit}, {bot_id, pk}) {
      return chatbot.deleteChatBotRegularSending(bot_id, pk)
        .then((d) => {
          return d.data
        })
        .catch((e) => {
          alert('エラーが発生いたしました。')
        })
    },
    updateChatBotRegularSending ({commit}, {bot_id, pk, data}) {
      return chatbot.updateChatBotRegularSending(bot_id, pk, data)
        .then(() => {
          return
        })
        .catch((e) => {
          alert('エラーが発生いたしました。')
        })
    },
    createSendScheduledMessage ({commit}, data) {
      return chatbot.createSendScheduledMessage(data)
        .then((d) => {
        })
        .catch((e) => {
          alert('エラーが発生いたしました。')
        })
    },
    getSendScheduledMessage ({commit}, {id, start_date, end_date}) {
      return chatbot.getSendScheduledMessage(id, start_date, end_date)
      .then((d) => {
        return d.data
      })
      .catch((e) => {
        alert('エラーが発生いたしました。')
      })
    },
    sendEmailContent ({commit}, data) {
      return chatbot.sendEmailContent(data)
    },
    checkExistChatBot ({commit}, data) {
      chatbot.checkExistChatBot(data)
        .then((d) => {
          return
        })
        .catch((e) => {
          alert('ロボを取得できませんでした。URLをもう一度ご確認の上アクセスをお願いいたします。')
          location.href = '/404' + '?cid=' + data.cid
        })
    },
    getChatBotPerformance ({commit}, {id, param}) {
      return chatbot.getChatBotPerformance(id, param)
        .then((d) => {
          return d.data
        })
        .catch((e) => {
          return {
            bot_id: id,
            taiosu: '-',
            kanryosu: '-',
            ridatsuten: '-',
            robotojiru: '-',
            browsertojiru: '-',
            betsurobo: '-'
          }
        })
    },
    getChatBotDetail ({commit}, id) {
      return chatbot.getChatBotDetail(id)
        .then((d) => {
          return d.data
        })
        .catch((e) => {
          alert('ロボの詳細情報取得に失敗いたしました。\nしばらくしてからのアクセスをお願いいたします。')
          return
        })
    },
    getChatBotStar ({commit}, id) {
      return chatbot.getChatBotStar(id)
        .then((d) => {
          return d.data
        })
        .catch((e) => {
          return {
            bot_id: id
          }
        })
    },
    getQuestionnaireData ({commit}, id) {
      return chatbot.getQuestionnaireData(id)
        .then((d) => {
          return d.data
          //return JSON.parse(d.data)
        })
        .catch((e) => {
          return {
            bot_id: id
          }
        })
    },
    dragScroll ({commit}, flg) {
      commit('DRAG_SCROLL', flg)
    },
    setModalChatBotDetail ({commit}, flg) {
      commit('OPEN_CHATBOT_DETAIL', flg)
    },
    PdfDownload ({commit}, pdfData) {
      return chatbot.PdfDownload(pdfData)
        .then((d) => {
          return d
        })
        .catch((e) => {
          return
        })
    },
    exportChatBotMiniVariableGroup ({commit}, data) {
      return chatbot.exportChatBotMiniVariableGroup(data)
        .then((d) => {
          return d.data
        })
        .catch((e) => {
          alert('エラーが発生いたしました。')
          return
        })
    },
    async importChatBotMiniVariableGroup ({commit}, data) {
      return await chatbot.importChatBotMiniVariableGroup(data)
        .then((d) => {
          commit('IMPORT_CMVG', JSON.parse(d.data))
          alert("ミニロボ変数をインポートしました")
          const robo_list = JSON.parse(d.data)
          return robo_list.find(robo => robo.bot_id === data.chatbot.bot_id)
        })
        .catch((e) => {
          let msg = 'エラーにより挿入できませんでした。ご確認をお願い致します。\n'
          msg += '列番号： ' + e.response.data.x + '\n行番号： ' + e.response.data.y + '\n'
          msg += 'エラー内容： ' + e.response.data.err
          alert(msg)
          return false
        })
    },
    answerOutput ({commit}, data) {
      chatbot.answerOutput(data)
    },
    getGoogleDriveFiles ({commit}, data) {
      return chatbot.getGoogleDriveFiles(data.user_id, data.folder_id)
        .then((d) => {
          return d.data
        })
        .catch((e) => {
          return []
        })
    },
    createGoogleDriveFolder ({commit}, data) {
      return chatbot.createGoogleDriveFolder(data)
        .then(() => {
          return
        })
        .catch((e) => {
        })
    },
    deleteGoogleDriveFolder ({commit}, data) {
      return chatbot.deleteGoogleDriveFolder(data)
        .then((d) => {
          if(d.data) {
            if(d.data.message) {
              if(d.data.message === 'exist-items') {
                alert('中にフォルダやファイルのあるフォルダは削除できません。')
              }
              if(d.data.message === 'other-exception') {
                alert('フォルダが無いか、削除する権限がありません。')
              }
            }
            return false
          } else {
            return true
          }
        })
        .catch((e) => {
          alert('エラーが発生いたしました。')
        })
    },
    realtimeSetScenario ({commit}, data) {
      commit('REAL_SET_SCENARIO', data)
    },
    realtimeCreateScenario ({commit}, data) {
      commit('REAL_CREATE_SCENARIO', data)
    },
    realtimeDeleteScenario ({commit}, data) {
      commit('REAL_DELETE_SCENARIO', data)
    },
    setIsChangeName ({commit}, flg) {
      commit('SET_IS_CHANGE_NAME', flg)
    },
    confirmByParts ({commit}, data) {
      commit('CONFIRM_BY_PARTS', data)
    },
    confirmByStories ({commit}, data) {
      commit('CONFIRM_BY_STORIES', data)
      commit('GET_ALL_STORY', data)
    },
    restoreParts ({commit}) {
      commit('RESTORE_PARTS')
    },
    changePartsTypePrev ({commit}) {
      commit('CHANGE_PARTS_TYPE_PREV')
    },
    changePartsPrev ({commit}) {
      commit('CHANGE_PARTS_PREV')
    },
    changePartsNext ({commit}) {
      commit('CHANGE_PARTS_NEXT')
    },
    changePartsTypeNext ({commit}) {
      commit('CHANGE_PARTS_TYPE_NEXT')
    },
    changeStoryParts ({commit}, data) {
      commit('CHANGE_STORY_PARTS', data)
    },
    storySet({commit}) {
      commit('ALL_STORY_SET')
    },
    getAllStory({commit}, data) {
      commit('GET_ALL_STORY', data)
    },
    updateConfirmStory({commit}, data) {
      return chatbot.UpdateStoryConfirm(data.name, data.story_confirm)
        .then(() => {
          commit('UPDATE_CONFIRM_STORY')
        })
    },
    getNextRobo ({commit}, companyid) {
      return chatbot.getNextRobo(companyid)
      .then((d) => {
        return d.data
      })
    },
    // ロボ引用設定モーダル表示
    changeModalSettingArguments ({commit}) {
      commit('CB_CHN_SETTING_ARGUMENTS')
    },
    /**
     * テンプレートロボコピー
     */
     copyTemplateRobo ({commit}, copyInfo) {
      return chatbot.copyTemplateRobo(copyInfo)
        .then(newRobo => {
          commit('SET_SCENARIO_TABLE', JSON.parse(newRobo.data))
          return JSON.parse(newRobo.data)
        })
    },
    /**
     * コピー後ロボ削除
     */
     deleteCopyRobo ({commit}, scenario_name) {
      chatbot.deleteCopyRobo(scenario_name)
        .then(() => {
          commit('DEL_SCENARIO_TABLE', scenario_name)
        })
        .catch(error => {
          console.error(error)
        })
    },
    /**
     * ロボ作成依頼送信
     */
     roboCreateRequest ({commit}, sendData) {
      return chatbot.roboCreateRequest(sendData)
        .then(result => {
          return result.data
        })
    },
    /**
     * プルダウン値export
     */
    exportPulldown ({commit}, {scenario_name,scenario_pk}) {
      commit('PLD_EXPORT', {scenario_name,scenario_pk})
    },

  },
  mutations: {
    CB_GET (state, data) {
      state.isCBLoading = false
      if (data.length > 0) {
        state.chatbots = data
        state.chatbots.sort((a, b) => {
          return a.order_num - b.order_num
        })
      }
    },
    CB_GET_ONE (state, data) {
      state.chatbot = {
        name: data.name,
        bot_id: data.bot_id,
        group: data.group,
        icon: data.icon_data ? data.icon_data : "",
        target_url: data.target_url ? data.target_url : "",
        scenario_name: data.scenario_name,
        left: 0
      }
    },
    CB_GET_RMD (state, {cid, botid}) {
      state.isCBLoading = true
      chatbot.getChatBotRecommend(cid, botid)
        .then((d) => {
          let data = JSON.parse(d.data)
          state.isCBLoading = false
          for (let i in data.own) {
            if (data.own[i].chatbot_mini.length > 0) {
              for (let j in data.own[i].chatbot_mini) {
                if (data.own[i].chatbot_mini[j].is_recruit) {
                  let tempOwn = data.own[i].chatbot_mini[j]
                  data.own[i].name = tempOwn.name
                  data.own[i].pk = tempOwn.pk
                }
              }
            }
          }
          state.recommendBots = data.own
          for (let i in data.other) {
            if (data.other[i].chatbot_mini.length > 0) {
              for (let j in data.other[i].chatbot_mini) {
                if (data.other[i].chatbot_mini[j].is_recruit) {
                  let tempOther = data.other[i].chatbot_mini[j]
                  data.other[i].name = tempOther.name
                  data.other[i].pk = tempOther.pk
                }
              }
            }
          }
          state.recommendBotsOther = data.other
        })
        .catch((e) => {
          state.isCBLoading = false
          alert('エラーが発生いたしました。')
        })
    },
    CB_GET_STS (state, botid) {
      chatbot.getChatBotStatus(botid)
        .then((d) => {
          state.chatbotStatus = d.data
        })
        .catch((e) => {
          alert('エラーが発生いたしました。')
        })
    },
    CB_CREATE (state, data) {
      state.chatbots.push(data)
    },
    CB_DELETE (state, {companyid, chatbotID}) {
      chatbot.deleteChatBot(companyid, chatbotID)
        .then(() => {
          for (var idx in state.chatbots) {
            if (state.chatbots[idx].bot_id === chatbotID) {
              state.chatbots.splice(idx, 1)
            }
          }
        })
        .catch((e) => {
          alert('エラーが発生いたしました。')
        })
    },
    CB_SET (state, data) {
      const upData = JSON.parse(data)
      state.isStartBotSet += 1
      for (let idx in state.chatbots) {
        if (state.chatbots[idx].bot_id === upData.bot_id) {
          state.chatbots.splice(idx, 1, upData)
        }
      }
      if (state.selectChatbot) {
        state.selectChatbot = state.chatbots.find((bot) => bot.bot_id == state.selectChatbot.bot_id)
      }
      state.isStartBotSet -= 1
    },
    CB_SET_FAILURE (state) {
      state.isStartBotSet -= 1
    },
    CB_SETS_ORD (state, chatbots) {
      chatbot.updateChatBotsOrder({ 'chatbots': chatbots })
        .then((d) => {
          state.chatbots = JSON.parse(d.data)
        })
        .catch((e) => {
          alert('エラーが発生いたしました。')
        })
    },
    CB_SCN_SET_UNDO (state, {companyid, scenarioName}) {
      // 保存用キー
      if (!scenarioName) {
        scenarioName = state.selectScenarioName
      }
      const storageKey = 'undodata_' + companyid + '_' + scenarioName
      const indexKey   = 'undodata-index_' + companyid + '_' + scenarioName
      // Undo用シナリオ保存
      let undoData = JSON.parse(sessionStorage.getItem(storageKey))
      if (undoData) {
        // 現状のシナリオテーブルを先頭にする
        state.undoData = []
        state.undoData.push(state.scenarioTable)
        // Undo途中のデータを追加していく
        for (let idx = state.currentUndoIndex; idx < state.undoMax; idx++) {
          if (undoData[idx]) {
            state.undoData.push(undoData[idx])
          }
        }
      } else {
        // 取得できなかった場合、現状のシナリオテーブルを最新として格納しておく
        state.undoData = []
        state.undoData.push(state.scenarioTable)
      }

      if (state.currentUndoIndex > 0) {
        // 差し先を先頭にする
        state.currentUndoIndex = 0
      }
      sessionStorage.setItem(storageKey, JSON.stringify(state.undoData))
      sessionStorage.setItem(indexKey, state.currentUndoIndex)
    },
    CB_SCN_UNDO (state, {companyid, scenarioName}) {
      // 保存用キー
      const storageKey = 'undodata_' + companyid + '_' + scenarioName
      const indexKey   = 'undodata-index_' + companyid + '_' + scenarioName
      // undoデータを取得する
      let undoData = JSON.parse(sessionStorage.getItem(storageKey))
      if (undoData) {
        if (undoData.length > 0 && undoData.length > state.currentUndoIndex) {
          // 次のインデックスを指す
          state.currentUndoIndex++
          state.scenarioTable = undoData[state.currentUndoIndex]
          // 現状を保存する
          chatbot.saveScenarioList(state.scenarioTable, companyid, scenarioName)
            .catch((e) => {
              alert('エラーが発生いたしました。')
              return
            })
        }
      } else {
        // 取得できなかった場合、現状のシナリオテーブルを最新として格納しておく
        state.undoData = []
        state.undoData.push(state.scenarioTable)
      }
      if (state.currentUndoIndex > state.undoMax) {
        state.currentUndoIndex = (state.undoMax -1)
      }
      sessionStorage.setItem(indexKey, state.currentUndoIndex)
    },
    CB_SCN_REDO (state, {companyid, scenarioName}) {
      // 保存用キー
      const storageKey = 'undodata_' + companyid + '_' + scenarioName
      const indexKey   = 'undodata-index_' + companyid + '_' + scenarioName
      // undoデータを取得する
      let undoData = JSON.parse(sessionStorage.getItem(storageKey))
      if (undoData) {
        if (undoData.length > 0 && state.currentUndoIndex > 0) {
          // 前のインデックスを指す
          state.currentUndoIndex--
          state.scenarioTable = undoData[state.currentUndoIndex]
          // 現状を保存する
          chatbot.saveScenarioList(state.scenarioTable, companyid, scenarioName)
            .catch((e) => {
              alert('エラーが発生いたしました。')
            })
        }
      } else {
        // 取得できなかった場合、現状のシナリオテーブルを最新として格納しておく
        state.undoData = []
        state.undoData.push(state.scenarioTable)
      }
      if (state.currentUndoIndex < 0) {
        state.currentUndoIndex = 0
      }
      sessionStorage.setItem(indexKey, state.currentUndoIndex)
    },
    CB_SCN_SAVE (state, {companyid, scenarioName, d}) {
      state.scenarioTable.push(d.data)
      // 保存用キー
      const storageKey = 'undodata_' + companyid + '_' + scenarioName
      const indexKey   = 'undodata-index_' + companyid + '_' + scenarioName
      // Undo用シナリオ保存
      let undoData = JSON.parse(sessionStorage.getItem(storageKey))
      if (undoData) {
        // 現状のシナリオテーブルを先頭にする
        state.undoData = []
        state.undoData.push(state.scenarioTable)
        // Undo途中のデータを追加していく
        for (let idx = state.currentUndoIndex; idx < state.undoMax; idx++) {
          if (undoData[idx]) {
            state.undoData.push(undoData[idx])
          }
        }
      } else {
        // 取得できなかった場合、現状のシナリオテーブルを最新として格納しておく
        state.undoData = []
        state.undoData.push(state.scenarioTable)
      }

      if (state.currentUndoIndex > 0) {
        // 差し先を先頭にする
        state.currentUndoIndex = 0
      }
      sessionStorage.setItem(storageKey, JSON.stringify(state.undoData))
      sessionStorage.setItem(indexKey, state.currentUndoIndex)
    },
    CB_SCN_DEMO_SAVE (state, data) {
      state.scenarioTable.push(data)
    },
    CB_SCN_DELETE (state, {companyid, scenarioName, scenarioId}) {
      chatbot.deleteScenario(companyid, scenarioName, scenarioId)
        .then(() => {
          for (var idx in state.scenarioTable) {
            if (state.scenarioTable[idx].beforenode === scenarioId) {
              state.scenarioTable.splice(idx, 1)
            }
          }
          // 保存用キー
          const storageKey = 'undodata_' + companyid + '_' + scenarioName
          const indexKey   = 'undodata-index_' + companyid + '_' + scenarioName
          // Undo用シナリオ保存
          let undoData = JSON.parse(sessionStorage.getItem(storageKey))
          if (undoData) {
            // 現状のシナリオテーブルを先頭にする
            state.undoData = []
            state.undoData.push(state.scenarioTable)
            // Undo途中のデータを追加していく
            for (let idx = state.currentUndoIndex; idx < state.undoMax; idx++) {
              if (undoData[idx]) {
                state.undoData.push(undoData[idx])
              }
            }
          } else {
            // 取得できなかった場合、現状のシナリオテーブルを最新として格納しておく
            state.undoData = []
            state.undoData.push(state.scenarioTable)
          }

          if (state.currentUndoIndex > 0) {
            // 差し先を先頭にする
            state.currentUndoIndex = 0
          }
          sessionStorage.setItem(storageKey, JSON.stringify(state.undoData))
          sessionStorage.setItem(indexKey, state.currentUndoIndex)
        })
        .catch((e) => {
          alert('エラーが発生いたしました。')
        })
    },
    CB_SCN_DELETE_DEMO (state, scenarioId) {
      for (var idx in state.scenarioTable) {
        if (state.scenarioTable[idx].beforenode === scenarioId) {
          state.scenarioTable.splice(idx, 1)
        }
      }
    },
    CB_SCN_DELETE_LIST (state, {companyid, scenarioName}) {
      return chatbot.deleteScenarioList(companyid, scenarioName)
        .then(() => {
          state.scenarioTable = []
          // 保存用キー
          const storageKey = 'undodata_' + companyid + '_' + scenarioName
          const indexKey   = 'undodata-index_' + companyid + '_' + scenarioName
          // Undo用シナリオ保存
          let undoData = JSON.parse(sessionStorage.getItem(storageKey))
          if (undoData) {
            // 現状のシナリオテーブルを先頭にする
            state.undoData = []
            state.undoData.push(state.scenarioTable)
            // Undo途中のデータを追加していく
            for (let idx = state.currentUndoIndex; idx < state.undoMax; idx++) {
              if (undoData[idx]) {
                state.undoData.push(undoData[idx])
              }
            }
          } else {
            // 取得できなかった場合、現状のシナリオテーブルを最新として格納しておく
            state.undoData = []
            state.undoData.push(state.scenarioTable)
          }

          if (state.currentUndoIndex > 0) {
            // 差し先を先頭にする
            state.currentUndoIndex = 0
          }
          sessionStorage.setItem(storageKey, JSON.stringify(state.undoData))
          sessionStorage.setItem(indexKey, state.currentUndoIndex)
          alert('削除しました。')
          return
        })
        .catch((e) => {
          alert('削除に失敗しました。')
        })
    },
    CB_SCN_TMP_GET (state) {
      chatbot.getScenarioTemplate()
        .then((d) => {
          state.roboPartsSet = d.data
        })
        .catch((e) => {
          alert('エラーが発生いたしました。')
        })
    },
    CB_SCN_IMPORT_FLG (state, flag) {
      state.scenarioInportFlag = flag
    },
    CB_SCN_IMPORT_LIST (state) {
      state.isRoboPartsSetView = false
      state.copyScenarioTable = []
    },
    DISP_ROBO_PARTS_SET_VIEW (state, roboPartsSet) {
      state.isRoboPartsSetView = true
      state.scenarioTable = roboPartsSet.scenario_list
      state.selectScenario = roboPartsSet.robo_parts_set_id
      state.selectRoboPartsSet = roboPartsSet
    },
    CB_SCN_TMP_LSET (state, scenarioList) {
      state.selectScenario = ''
      state.scenarioTable = scenarioList.scenario_list
      state.selectScenario = scenarioList.template_name
      state.selectTemplateId = scenarioList.template_id
      state.isRoboPartsSetView = true
    },
    CB_SCN_TMP_SET (state, {data, scenario}) {
        for (const i in state.scenarioTable) {
          if (state.scenarioTable[i].pk == undefined) {
            state.scenarioTable[i].pk = data[i].pk
          }
        }
        state.scenarioNodeData = []
        state.isConnecting = false
        state.modalScenario.mainmessage = state.modalScenario.mainmessage.replace('[cv]', '').replace('[/cv]', '')
        for (const i in state.scenarioTable) {
          if (state.scenarioTable[i].beforenode === scenario.beforenode) {
            state.scenarioTable.splice(i, 1, scenario)
          }
        }
    },
    CB_SCN_TMP_SET_FAILURE (state) {
      state.isSCNLoading = false
    },
    CB_SCN_TMP_DEL (state, beforenode) {
      for (var i in state.scenarioTable) {
        if (state.scenarioTable[i].beforenode === beforenode) state.scenarioTable.splice(i, 1)
      }
      chatbot.updateScenarioTemplate(state.selectTemplateId, state.scenarioTable)
        .then(() => {
        })
        .catch((e) => {
          alert('エラーが発生いたしました。')
        })
    },
    CB_SCN_TMP_DEL_LIST (state) {
      for (var i in state.roboPartsSet) {
        if (state.scenarioTable[i].template_id === state.selectTemplateId) state.roboPartsSet.splice(i, 1)
      }
      chatbot.deleteScenarioTemplate(state.selectTemplateId)
        .then(() => {
          state.selectTemplateId = ''
          state.scenarioTable = []
          state.selectScenario = ''
          alert('削除しました。')
        })
        .catch((e) => {
          alert('削除に失敗しました。')
        })
    },
    CB_SCN_TMP_SAVE (state, scenario) {
      state.scenarioTable.push(scenario)
      chatbot.updateScenarioTemplate(state.selectTemplateId, state.scenarioTable)
        .then(() => {
        })
        .catch((e) => {
          alert('エラーが発生いたしました。')
        })
    },
    CB_SCN_GET (state, {companyid, scenarioName}) {
      state.selectScenario = ''
      state.selectTemplateId = ''
      state.isSCNLoading = true
      state.scenarioNodeData = []
      state.isConnecting = false
      chatbot.getScenario(companyid, scenarioName)
        .then((d) => {
          state.scenarioTable = d.data
          // 保存用キー
          const storageKey = 'undodata_' + companyid + '_' + scenarioName
          const indexKey   = 'undodata-index_' + companyid + '_' + scenarioName
          state.undoData = JSON.parse(sessionStorage.getItem(storageKey))
          if (!state.undoData) {
            // Undo用データ初回退避
            state.undoData = []
            state.undoData.push(state.scenarioTable)
            sessionStorage.setItem(storageKey, JSON.stringify(state.undoData))
            // 初回インデックス
            sessionStorage.setItem(indexKey, 0)
            state.currentUndoIndex = 0
          } else if (state.undoData && state.scenarioInportFlag) {
            // インポート後の読み込みの場合
            state.scenarioInportFlag = false
            // 先頭に最新のシナリオテーブルを保存する
            state.undoData.unshift(state.scenarioTable)
            sessionStorage.setItem(storageKey, JSON.stringify(state.undoData))
            // 途中のインデックスを取得
            state.currentUndoIndex = sessionStorage.getItem(indexKey)
          } else {
            // 途中のインデックスを取得
            state.currentUndoIndex = sessionStorage.getItem(indexKey)
          }
          state.isRoboPartsSetView = false
          setTimeout(() => {
            state.selectScenario = scenarioName
            state.isSCNLoading = false
          }, 700)
        })
        .catch((e) => {
          alert('エラーが発生いたしました。')
        })
    },
    CB_SCN_DEMO (state, type) {
      chatbot.getScenarioDemo(type)
        .then((d) => {
          state.scenarioTable = d.data
        })
        .catch((e) => {
          alert('エラーが発生いたしました。')
        })
    },
    // シナリオ一つだけ
    CB_SCN_GET_ONE (state, {companyid, scenarioName, node, rate, minipk}) {
      state.isSCNLoading = true
      // var r = rate
      // if (r == 0) r = 100
      chatbot.getScenarioOne(companyid, scenarioName, node, minipk)
        .then((d) => {
          setTimeout(() => {
            state.scenario = d.data
            state.isSCNLoading = false
            state.minipk = minipk
            if (node == 'INITIALIZE'){
              state.isNoStartScenerio = false
            }
          }, 2000 * (state.isAutomatic ? 1 : 0.2))
        })
        .catch((e) => {
          if(node == 'INITIALIZE'){
            state.isNoStartScenerio = true
          }
          state.isSCNLoading = false
          state.isAutomatic = false
          state.talkEnd = true
        })
    },
    // シナリオ一つだけ Temp
    CB_SCN_GET_ONE_T (state, {companyid, scenarioName, node, rate, minipk}) {
      state.isSCNLoading = true
      var r = rate
      if (r == 0) r = 1000
      chatbot.getScenarioOne(companyid, scenarioName, node, minipk)
        .then((d) => {
          setTimeout(() => {
            state.scenarioTemp = d.data
            state.isSCNLoading = false
            state.minipk = minipk
          }, 1500 * rate)
        })
        .catch((e) => {
          state.isSCNLoading = false
        })
    },
    CB_MINI_SET (state, pk) {
      state.minipk = pk
    },
    // パーツセット取得
    GET_ROBO_PARTS_SET (state, roboPartsSet) {
      state.roboPartsSet = roboPartsSet
    },
    // パーツセット作成
    CREATE_ROBO_PARTS_SET (state, roboPartsSet) {
      state.roboPartsSet.push(roboPartsSet)
    },
    // パーツセット更新
    UPDATE_ROBO_PARTS_SET (state, roboPartsSet) {
      for (let idx in state.roboPartsSet) {
        if(state.roboPartsSet[idx].robo_parts_set_id === roboPartsSet.robo_parts_set_id) {
          state.roboPartsSet.splice(idx, 1, roboPartsSet)
          break
        }
      }
    },
    // パーツセット削除
    DELETE_ROBO_PARTS_SET (state, roboPartsSet) {
      for (let idx in state.roboPartsSet) {
        if(state.roboPartsSet[idx].robo_parts_set_id === roboPartsSet.robo_parts_set_id) {
          state.roboPartsSet.splice(idx, 1)
          break
        }
      }
    },
    // パーツセット入力
    INPUT_ROBO_PARTS_SET (state, roboPartsSet) {
      for (let idx in state.scenarioTable) {
        state.scenarioTable.splice(idx, 1, roboPartsSet.scenario_list[idx])
      }
    },
    // パーツセット出力
    OUTPUT_ROBO_PARTS_SET (state, roboPartsSet) {
      for (let idx in state.scenarioTable) {
        state.scenarioTable.splice(idx, 1, roboPartsSet.scenario_list[idx])
      }
    },
    // パーツセット進入時設定
    SET_ROBO_PARTS_SET_INSIDE (state, {name, node}) {
      state.roboPartsSetOutsideScenario = name
      state.roboPartsSetNextNode = node
    },
    // パーツセット化モーダル表示
    EXPORT_ROBO_PARTS_SET (state) {
      state.isModalCreateScenario = false
      state.isModalEditScenario = false
      state.isModalDeleteScenario = false
      state.isModalDeleteListScenario = false
      state.isModalExportListScenario = true
      state.isModalImportListScenario = false
      state.isModalAllPartsConfirmListScenario = false
      state.isModalSettingArguments = false
    },
    // シナリオのパーツセット化(エクスポート)
    CB_SCN_EXPORT_LIST (state, parts_set) {
      state.roboPartsSet.push(parts_set)
    },
    CB_CLG_SET (state, {message, speaker}) {
      var data = {}
      if (speaker === 'other' && message.mainmessage != null) {
        message['speaker'] = 'other'
        state.chatbotLogs.push(message)
      } else if (speaker === 'other' && message.mainmessage == null) {
        data = {
          mainmessage: message,
          speaker: 'other'
        }
        state.chatbotLogs.push(data)
      } else {
        data = {
          mainmessage: message.message,
          speaker: 'my'
        }
        state.chatbotLogs.push(data)
      }
    },
    CB_SCN_SET (state, {companyid, scenarioName, scenario}) {
      if (state.isRoboPartsSetView) {
        for (let idx in state.selectRoboPartsSet.scenario_list) {
          if (state.selectRoboPartsSet.scenario_list[idx].beforenode === scenario.beforenode) {
            let scenario_copy = _.cloneDeep(scenario)
            scenario_copy.beforenodeX = state.selectRoboPartsSet.scenario_list[idx].beforenodeX
            scenario_copy.beforenodeY = state.selectRoboPartsSet.scenario_list[idx].beforenodeY
            state.selectRoboPartsSet.scenario_list.splice(idx, 1, scenario_copy)
          }
        }
      }
      // ↓これ何の処理？
      for (let idx in state.scenarioTable) {
        if (state.scenarioTable[idx].pk == undefined) {
          state.scenarioTable[idx].pk = d.data[idx].pk
        }
      }
      state.scenarioNodeData = []
      state.isConnecting = false
      state.modalScenario.mainmessage = state.modalScenario.mainmessage.replace('[cv]', '').replace('[/cv]', '')
      for (let idx in state.scenarioTable) {
        if (state.scenarioTable[idx].beforenode === scenario.beforenode) {
          let scenario_copy = _.cloneDeep(scenario)
          scenario_copy.beforenodeX = state.scenarioTable[idx].beforenodeX
          scenario_copy.beforenodeY = state.scenarioTable[idx].beforenodeY
          state.scenarioTable.splice(idx, 1, scenario_copy)
        }
      }
      if (!state.isRoboPartsSetView) {
        // 保存用キー
        const storageKey = 'undodata_' + companyid + '_' + scenarioName
        const indexKey   = 'undodata-index_' + companyid + '_' + scenarioName
        // Undo用シナリオ保存
        let undoData = JSON.parse(sessionStorage.getItem(storageKey))
        if (undoData) {
          // 現状のシナリオテーブルを先頭にする
          state.undoData = []
          state.undoData.push(state.scenarioTable)
          // Undo途中のデータを追加していく
          for (let idx = state.currentUndoIndex; idx < state.undoMax; idx++) {
            if (undoData[idx]) {
              state.undoData.push(undoData[idx])
            }
          }
        } else {
          // 取得できなかった場合、現状のシナリオテーブルを最新として格納しておく
          state.undoData = []
          state.undoData.push(state.scenarioTable)
        }

        if (state.currentUndoIndex > 0) {
          // 差し先を先頭にする
          state.currentUndoIndex = 0
        }
        sessionStorage.setItem(storageKey, JSON.stringify(state.undoData))
        sessionStorage.setItem(indexKey, state.currentUndoIndex)
      }
     },
    CB_SCN_SET_ERROR (state) {
      state.isSCNLoading = false
    },
    CB_SCN_SET_DEMO (state, scenario) {
      state.scenarioNodeData = []
      state.isConnecting = false
      for (var idx in state.scenarioTable) {
        if (state.scenarioTable[idx].beforenode === scenario.beforenode) {
          state.scenarioTable.splice(idx, 1, scenario)
        }
      }
    },
    CB_SCN_SET_IMG (state, data) {
      chatbot.updateScenarioImage(data)
        .then((d) => {
          state.scenarioNodeData = []
          state.isConnecting = false
          for (var idx in state.scenarioTable) {
            if (state.scenarioTable[idx].beforenode === data.scenario.beforenode) {
              var setScenario = data.scenario
              setScenario.image = d.data.image
              setScenario.image_ref = d.data.image_ref
              state.scenarioTable.splice(idx, 1, setScenario)
            }
          }
        })
        .catch((e) => {
          alert('エラーが発生いたしました。')
        })
      },
    CB_SCN_SAVE_NAME (state, scenarioName) {
      state.selectScenario = scenarioName
    },
    CB_SCN_NAME_GET (state, {companyid}) {
      chatbot.getScenarioName(companyid)
        .then((d) => {
          state.scenarioNameList = d.data
      })
        .catch((e) => {
          alert('エラーが発生いたしました。')
        })
    },
    CB_SCN_IDX (state, index) {
      state.scenarioIndex = index
    },
    CB_SCN_EDIT_STATS (state, data) {
      state.scenarioEditStats = data
    },
    SCN_PARTS_CONF (state, data) {
      state.scenarioTable = state.scenarioTable.map(e => ({ ...e, is_confirm: data.flg }))
      state.confirmLoading = false
    },
    SCN_PARTS_CONF_LOAD (state, flg) {
      state.confirmLoading = flg
    },
    CB_CHN_CRE (state) {
      state.isModalCreateScenario = true
      state.isModalEditScenario = false
      state.isModalDeleteScenario = false
      state.isModalDeleteListScenario = false
      state.isModalExportListScenario = false
      state.isModalImportListScenario = false
      state.isModalAllPartsConfirmListScenario = false
      state.isModalSettingArguments = false
    },
    CB_CHN_EDI (state) {
      state.isModalCreateScenario = false
      state.isModalEditScenario = true
      state.isModalDeleteScenario = false
      state.isModalDeleteListScenario = false
      state.isModalExportListScenario = false
      state.isModalImportListScenario = false
      state.isModalAllPartsConfirmListScenario = false
      state.isModalSettingArguments = false
    },
    CB_CHN_DEL (state) {
      state.isModalCreateScenario = false
      state.isModalEditScenario = false
      state.isModalDeleteScenario = true
      state.isModalDeleteListScenario = false
      state.isModalExportListScenario = false
      state.isModalImportListScenario = false
      state.isModalAllPartsConfirmListScenario = false
      state.isModalSettingArguments = false
    },
    CB_NOD_DEL (state, data) {
      state.modalScenario = data.scenario
      state.modalScenarioIndex = data.index
      state.isModalCreateScenario = false
      state.isModalEditScenario = false
      state.isModalDeleteScenario = false
      state.isModalDeleteNode = true
      state.isModalDeleteListScenario = false
      state.isModalExportListScenario = false
      state.isModalImportListScenario = false
      state.isModalAllPartsConfirmListScenario = false
      state.isModalSettingArguments = false
    },
    CB_CHN_DEL_LIST (state) {
      state.isModalCreateScenario = false
      state.isModalEditScenario = false
      state.isModalDeleteScenario = false
      state.isModalDeleteListScenario = true
      state.isModalExportListScenario = false
      state.isModalImportListScenario = false
      state.isModalAllPartsConfirmListScenario = false
      state.isModalSettingArguments = false
    },
    CB_CHN_IMP_LIST (state) {
      state.isModalCreateScenario = false
      state.isModalEditScenario = false
      state.isModalDeleteScenario = false
      state.isModalDeleteListScenario = false
      state.isModalExportListScenario = false
      state.isModalImportListScenario = true
      state.isModalAllPartsConfirmListScenario = false
      state.isModalSettingArguments = false
    },
    CB_CHN_SETTING_ARGUMENTS (state) {
      state.isModalCreateScenario = false
      state.isModalEditScenario = false
      state.isModalDeleteScenario = false
      state.isModalDeleteListScenario = false
      state.isModalExportListScenario = false
      state.isModalImportListScenario = false
      state.isModalAllPartsConfirmListScenario = false
      state.isModalSettingArguments = true
    },
    CB_CHN_PAR_LIST (state) {
      state.isModalCreateScenario = false
      state.isModalEditScenario = false
      state.isModalDeleteScenario = false
      state.isModalDeleteListScenario = false
      state.isModalExportListScenario = false
      state.isModalImportListScenario = false
      state.isModalAllPartsConfirmListScenario = true
      state.isModalSettingArguments = false
    },
    CB_CHN_ALL (state) {
      state.isModalCreateScenario = false
      state.isModalEditScenario = false
      state.isModalDeleteScenario = false
      state.isModalDeleteListScenario = false
      state.isModalExportListScenario = false
      state.isModalImportListScenario = false
      state.isModalAllPartsConfirmListScenario = false
      state.isModalSettingArguments = false
    },
    CB_SEL_SCN (state, scenario) {
      state.modalScenario = scenario
      if (state.modalScenario.status == 4) {
        if (state.modalScenario.parameter == null || Object.keys(state.modalScenario.parameter).length == 0) {
          state.modalScenario.parameter = {}
          state.modalScenario.parameter.user_hash = []
          state.modalScenario.parameter.user_hash_sub = []
          state.modalScenario.parameter.user_hash_share = []
          state.modalScenario.parameter.holiday_list= []
          state.modalScenario.parameter.work_time_start = 9
          state.modalScenario.parameter.work_time_end = 18
          state.modalScenario.parameter.interval = 0
          state.modalScenario.parameter.mtg_time = 1
          state.modalScenario.parameter.count = 3
          state.modalScenario.parameter.after = 1
          state.modalScenario.parameter.until = 30
          state.modalScenario.parameter.is_AND = false
          state.modalScenario.parameter.public_holiday = false
          state.modalScenario.parameter.mtg_time_hour = 1
          state.modalScenario.parameter.mtg_time_minute = 0
        }
      }
    },
    CB_DEMO_SEL_SCN (state, beforenode) {
      for (let s of state.scenarioTable) {
        if (s.beforenode === beforenode) {
          state.modalScenario = s
          break
        }
      }
    },
    CB_SEL_SCN_LIST (state, {flg, scenario}) {
      if (!scenario) state.selectScenarioList = []
      if (flg) state.selectScenarioList.push({
        scenario: scenario,
        description: ''
      })
      else for (var i in state.selectScenarioList) if (state.selectScenarioList[i].scenario.beforenode == scenario.beforenode) state.selectScenarioList.splice(i, 1)
    },
    CB_SCN_DEP_CHG (state, {scenario, description}) {
      for (var i in state.selectScenarioList) if (state.selectScenarioList[i].scenario.beforenode == scenario.beforenode) state.selectScenarioList[i].description = description
    },
    CB_RND_SEL (state, {category, type}) {
      var randIdx = Math.round(Math.random() * (state.stores.length - 1))
      var limit = 0
      while ((state.stores[randIdx].scenario_list.length < type || limit < 20) && state.stores[randIdx].category != category) {
        randIdx = Math.round(Math.random() *(state.stores.length - 1))
        limit++
      }
      // alert(JSON.stringify(state.stores[randIdx].scenario_list))
      state.scenarioTable = state.stores[randIdx].scenario_list
      state.selectStore   = state.stores[randIdx]
    },
    CB_SET_SCN (state, list) {
      state.scenarioTable = list.scenario_list
      state.selectStore   = list
      if (list['edit_list']) state.selectScenarioList = list.edit_list
      else state.selectScenarioList = []
    },
    CB_CLS_MDL (state) {
      state.isModalCreateScenario = false
      state.isModalEditScenario = false
      state.isModalDeleteScenario = false
      state.isModalDeleteNode = false
      state.isModalDeleteListScenario = false
      state.isModalExportListScenario = false
      state.isModalImportListScenario = false
      state.isModalAllPartsConfirmListScenario = false
      state.isConfirmByParts = false
      state.isConfirmByStories = false
      state.isModalSettingArguments = false
    },
    CB_CHN_DRP (state, index) {
      if (index === -1) state.isDrop = false
      else state.isDrop = !state.isDrop
      state.scenarioPartsIndex = index
    },
    CB_CHN_DRP_LIST (state, {index, roboPartsSet}) {
      if (!roboPartsSet) {
        state.isDrop = false
      } else {
        state.isDrop = !state.isDrop
      }
      state.scenarioPartsIndex = index
      state.dropRoboPartsSet = roboPartsSet
    },
    CB_CHN_CON (state, {flg, scenario}) {
      state.isConnecting = flg
      if (flg) {
        state.scenarioNodeData.push(scenario)
        if (Object.keys(state.scenarioNodeData).length > 2) state.scenarioNodeData.splice(1, 1)
      } else {
        state.scenarioNodeData = []
      }
    },
    CB_SET_IDX (state, index) {
      state.nextNode = index
    },
    CB_SET_PATH_SCN (state, scenario) {
      state.pathScenario = scenario
    },
    CB_SCN_COPY (state) {
      // ローカルストレージに保存
      state.isCopy = true
      state.isCut = false
      state.isPaste = true
      localStorage.setItem('SCENARIO_IS_COPY', 1)
      localStorage.setItem('SCENARIO_IS_CUT', 0)
      localStorage.setItem('COPY_SCENARIO', JSON.stringify(state.modalScenario))
    },
    CB_SCN_CUT (state) {
      // ローカルストレージに保存
      state.isCopy = false
      state.isCut = true
      state.isPaste = true
      localStorage.setItem('SCENARIO_IS_COPY', 0)
      localStorage.setItem('SCENARIO_IS_CUT', 1)
      localStorage.setItem('SCENARIO_CUT_TEMP_ID', state.selectTemplateId)
      localStorage.setItem('SCENARIO_CUT_SCE_ID', state.modalScenario.name)
      localStorage.setItem('COPY_SCENARIO', JSON.stringify(state.modalScenario))
    },
    CB_SCN_SET_PASTE_FLG (state, isPaste, isCopy, isCut) {
      state.isPaste = isPaste
      state.isCopy  = isCopy
      state.isCut   = isCut
    },
    CB_SCN_PASTE_MENU (state, {pasteX, pasteY}) {
      state.isPaste = true
      state.pasteX = pasteX === null ? 0 : pasteX
      state.pasteY = pasteY === null ? 0 : pasteY
    },
    CB_SCN_PASTE_SET (state) {
      state.copyScenario = JSON.parse(localStorage.getItem('COPY_SCENARIO'))
      // 座標を設定する
      state.copyScenario.beforenodeX = state.pasteX
      state.copyScenario.beforenodeY = state.pasteY
    },
    CB_SCN_DUP_SET (state) {
      state.copyScenario = JSON.parse(JSON.stringify(state.modalScenario))
      // 座標を少しずらす
      state.copyScenario.beforenodeX += 100
      state.copyScenario.beforenodeY += 100
    },
    CB_SCN_PASTE (state, companyid) {
      state.isCopy = Boolean(Number(localStorage.getItem('SCENARIO_IS_COPY')))
      state.isCut  = Boolean(Number(localStorage.getItem('SCENARIO_IS_CUT')))
      // 切り取り側をしてコピーしておく
      state.cutScenario = JSON.parse(JSON.stringify(state.copyScenario))
      // 選択中のシナリオに変更する
      if (!state.isRoboPartsSetView) {
        state.copyScenario.name = state.selectScenarioName
      } else {
        state.copyScenario.name = null
      }
      // nodeを新しく設定する
      state.copyScenario.beforenode = createUUID()
      // Startフラグのクリア
      state.copyScenario.start_flg = false
      // 接続先nodeのクリア シナリオ切替パーツは接続先が必要なため残す
      if (state.copyScenario.status != 3) {
        for (let select of state.copyScenario.select) {
          select.next_node = ''
        }
      }

      if (state.copyScenario.status === 19) {
        // 回答出力パーツはユーザーのGoogle連携と紐づいているのでパラメータクリア
        state.copyScenario.parameter = {
          format: 'csv',
          output: 'mail',
          mail_to: '',
          user_uuid: null
        }
      }

      // シナリオ編集での複製
      function saveUndoData (companyid, scenarioName) {
        if (state.isCopy) {
          // 保存用キー
          const storageKey = 'undodata_' + companyid + '_' + scenarioName
          const indexKey   = 'undodata-index_' + companyid + '_' + scenarioName
          // Undo用シナリオ保存
          let undoData = JSON.parse(sessionStorage.getItem(storageKey))
          if (undoData) {
            // 現状のシナリオテーブルを先頭にする
            state.undoData = []
            state.undoData.push(state.scenarioTable)
            // Undo途中のデータを追加していく
            for (let idx = state.currentUndoIndex; idx < state.undoMax; idx++) {
              if (undoData[idx]) {
                state.undoData.push(undoData[idx])
              }
            }
          } else {
            // 取得できなかった場合、現状のシナリオテーブルを最新として格納しておく
            state.undoData = []
            state.undoData.push(state.scenarioTable)
          }

          if (state.currentUndoIndex > 0) {
            // 差し先を先頭にする
            state.currentUndoIndex = 0
          }
          sessionStorage.setItem(storageKey, JSON.stringify(state.undoData))
          sessionStorage.setItem(indexKey, state.currentUndoIndex)
        }
      }
      chatbot.saveScenario({data: state.copyScenario}, companyid, state.copyScenario.name)
        .then((d) => {
          state.copyScenario.pk = d.data.pk
          state.scenarioTable.push(state.copyScenario)

          if (state.copyScenario.status === 5) {
            // 画像
            let scenarioData = {
              image_ref: state.copyScenario.image_ref,
              scenario: state.copyScenario,
              template_id: ''
            }
            chatbot.updateScenarioImage(scenarioData)
              .then((d) => {
                state.scenarioNodeData = []
                state.isConnecting = false
                for (let idx in state.scenarioTable) {
                  if (state.scenarioTable[idx].beforenode === scenarioData.beforenode) {
                    state.copyScenario.image = d.data.image
                    state.copyScenario.image_ref = d.data.image_ref
                    state.scenarioTable.splice(idx, 1, state.copyScenario)
                  }
                }
                state.isEndPaste = true
                saveUndoData(companyid, state.selectScenarioName)
              })
              .catch((e) => {
                state.isEndPaste = true
                alert('エラーが発生いたしました。')
              })
          } else if (state.copyScenario.status === 14) {
            // 動画
            chatbot.uploadMovieFileCopy(state.copyScenario, state.copyScenario.movie_ref, '')
              .then((d) => {
                for (let idx in state.scenarioTable) {
                  if (state.scenarioTable[idx].beforenode === state.copyScenario.beforenode) {
                    state.copyScenario.movie = d.data.movie
                    state.copyScenario.movie_ref = d.data.movie_ref
                    state.scenarioTable.splice(idx, 1, state.copyScenario)
                  }
                }
                state.isEndPaste = true
                saveUndoData(companyid, state.selectScenarioName)
              })
              .catch((e) => {
                state.isEndPaste = true
                alert('エラーが発生いたしました。')
              })
          } else if (state.copyScenario.status === 18) {
            // ファイルダウンロード
            chatbot.uploadAttachmentFileCopy(state.cutScenario.pk, state.copyScenario.pk)
              .then((d) => {
                for (let idx in state.scenarioTable) {
                  if (state.scenarioTable[idx].beforenode === state.copyScenario.beforenode) {
                    state.copyScenario.parameter.attached_files = d.data.attached_files
                    state.scenarioTable.splice(idx, 1, state.copyScenario)
                  }
                }
                state.isEndPaste = true
                saveUndoData(companyid, state.selectScenarioName)
              })
              .catch((e) => {
                state.isEndPaste = true
                alert('エラーが発生いたしました。')
              })
          } else {
            // 画像と動画以外
            chatbot.updateScenario(state.copyScenario, companyid, state.copyScenario.name)
              .then(() => {
                for (let idx in state.scenarioTable) {
                  if (state.scenarioTable[idx].pk === undefined) {
                    state.scenarioTable[idx].pk = d.data[idx].pk
                  }
                }
                state.scenarioNodeData = []
                state.isConnecting = false
                state.modalScenario.mainmessage = state.modalScenario.mainmessage.replace('[cv]', '').replace('[/cv]', '')
                for (let idx in state.scenarioTable) {
                  if (state.scenarioTable[idx].beforenode === state.copyScenario.beforenode) {
                    state.scenarioTable.splice(idx, 1, state.copyScenario)
                  }
                }
                state.isEndPaste = true
                saveUndoData(companyid, state.selectScenarioName)
              })
              .catch((e) => {
                state.isEndPaste = true
                alert('エラーが発生いたしました。')
              })
          }
        })
        .catch((e) => {
          state.isEndPaste = true
          alert('エラーが発生いたしました。')
        })
    },
    CB_SCN_CUT_DEL (state, companyid) {
      let tempId = null
      let sceId  = null
      if (state.isCut) {
        const currentSelectId = state.isRoboPartsSetView ? state.selectTemplateId : state.selectScenarioName
        tempId = localStorage.getItem('SCENARIO_CUT_TEMP_ID')
        sceId = localStorage.getItem('SCENARIO_CUT_SCE_ID')
        // シナリオ編集画面のパーツを削除
        if (sceId === currentSelectId) {
          // 開いているシナリオが同じなら今まで通りの削除
          chatbot.deleteScenario(companyid, state.cutScenario.name, state.cutScenario.beforenode)
            .then(() => {
              for (var idx in state.scenarioTable) {
                if (state.scenarioTable[idx].beforenode === state.cutScenario.beforenode) {
                  state.scenarioTable.splice(idx, 1)
                }
              }
              state.isEndCutDelete = true
              // 保存用キー
              const storageKey = 'undodata_' + companyid + '_' + state.selectScenarioName
              const indexKey   = 'undodata-index_' + companyid + '_' + state.selectScenarioName
              // Undo用シナリオ保存
              let undoData = JSON.parse(sessionStorage.getItem(storageKey))
              if (undoData) {
                // 現状のシナリオテーブルを先頭にする
                state.undoData = []
                state.undoData.push(state.scenarioTable)
                // Undo途中のデータを追加していく
                for (let idx = state.currentUndoIndex; idx < state.undoMax; idx++) {
                  if (undoData[idx]) {
                    state.undoData.push(undoData[idx])
                  }
                }
              } else {
                // 取得できなかった場合、現状のシナリオテーブルを最新として格納しておく
                state.undoData = []
                state.undoData.push(state.scenarioTable)
              }

              if (state.currentUndoIndex > 0) {
                // 差し先を先頭にする
                state.currentUndoIndex = 0
              }
              sessionStorage.setItem(storageKey, JSON.stringify(state.undoData))
              sessionStorage.setItem(indexKey, state.currentUndoIndex)
            })
            .catch((e) => {
              state.isEndCutDelete = true
              alert('エラーが発生いたしました。')
            })
        } else {
          // 今開いていないシナリオのパーツを削除
          chatbot.cutdelScenario(state.cutScenario.pk)
            .then(() => {
              state.isEndCutDelete = true
              localStorage.setItem('OTHER_SCE_PASTE_' + state.cutScenario.name, state.cutScenario.name)
            })
            .catch((e) => {
              state.isEndCutDelete = true
              alert('エラーが発生いたしました。')
            })
        }
      } else if (state.isCopy) {
        if (state.isRoboPartsSetView) {
          if (tempId === state.selectTemplateId) {
            localStorage.setItem('OTHER_SCE_PASTE_' + state.cutScenario.name, state.cutScenario.name)
          }
        } else {
          if (sceId === state.selectScenarioName) {
            localStorage.setItem('OTHER_SCE_PASTE_' + state.cutScenario.name, state.cutScenario.name)
          }
        }
        state.isEndCutDelete = true
      }
    },
    CB_SCN_COPY_INFO_CLR (state) {
      state.isEndPaste = false
      state.isEndCutDelete = false
      state.isCopy = false
      state.isCut = false
      state.isPaste = false
      state.pasteX = 0
      state.pasteY = 0
      state.copyScenario = null
      state.CutScenario = null
      localStorage.removeItem('SCENARIO_IS_COPY')
      localStorage.removeItem('SCENARIO_IS_CUT')
      localStorage.removeItem('SCENARIO_CUT_TEMP_ID')
      localStorage.removeItem('SCENARIO_CUT_SCE_ID')
      localStorage.removeItem('COPY_SCENARIO')
    },
    CB_INT_SET_FLG (state, companyid) {
      for (var i in state.scenarioTable) {
        if (state.scenarioTable[i].start_flg) {
          state.scenarioTable[i].start_flg = false
          chatbot.updateScenario(state.scenarioTable[i], companyid, state.scenarioTable[i].name)
            .then(() => {
              for (var idx in state.scenarioTable) {
                if (state.scenarioTable[idx].beforenode === state.scenarioTable[i].beforenode) {
                  let scenario_copy = _.cloneDeep(state.scenarioTable[i])
                  scenario_copy.beforenodeX = state.scenarioTable[idx].beforenodeX
                  scenario_copy.beforenodeY = state.scenarioTable[idx].beforenodeY
                  state.scenarioTable.splice(idx, 1, scenario_copy)
                }
              }
            })
            .catch((e) => {
              alert('エラーが発生いたしました。')
            })
        }
      }
      state.modalScenario.start_flg = true
      chatbot.updateScenario(state.modalScenario, companyid, state.modalScenario.name)
        .then(() => {
          state.scenarioNodeData = []
          state.isConnecting = false
          for (var idx in state.scenarioTable) {
            if (state.scenarioTable[idx].beforenode === state.modalScenario.beforenode) {
              let scenario_copy = _.cloneDeep(state.modalScenario)
              scenario_copy.beforenodeX = state.scenarioTable[idx].beforenodeX
              scenario_copy.beforenodeY = state.scenarioTable[idx].beforenodeY
              state.scenarioTable.splice(idx, 1, scenario_copy)
            }
          }
        })
        .catch((e) => {
          alert('エラーが発生いたしました。')
        })
    },
    UPDATE_SCENARIO_TABLE (state, data) {
      state.scenarioTable = state.scenarioTable.map( (el) => {
        if (el.pk === data.pk) {
          return data
        } else {
          return el
        }
      })
    },
    SET_CB_ICON (state, data) {
      for (let idx in state.chatbots) {
        if (state.chatbots[idx].bot_id === data.bot_id) {
          state.chatbots.splice(idx, 1, data)
        }
      }
      state.selectChatbot = data
    },
    SET_CB_ICON_LOADING (state, flg) {
      state.isIconLoading = flg
    },
    SORT_CB (state, type) {
      if (type === 'reply') {
        if (state.isReplySort) state.chatbots.sort((a, b) => { return a.message_count - b.message_count })
        else state.chatbots.sort((a, b) => { return b.message_count - a.message_count })
        state.isReplySort = !state.isReplySort
      } else if (type === 'used') {
        if (state.isUsedSort) state.chatbots.sort((a, b) => { return a.message_count - b.message_count })
        else state.chatbots.sort((a, b) => { return b.message_count - a.message_count })
        state.isUsedSort = !state.isUsedSort
      } else if (type === 'default') {
        if (state.isDefaultSort) state.chatbots.sort((a, b) => { return a.order_num - b.order_num })
        else state.chatbots.sort((a, b) => { return b.order_num - a.order_num })
        state.isDefaultSort = !state.isDefaultSort
      }
    },
    CB_SEL (state, chatbot) {
      state.selectChatbot = chatbot
      state.selectScenarioBotName = chatbot.name
      state.selectScenarioName = chatbot.scenario_name
    },
    CB_SEL_TEMP (state, template) {
      state.scenarioTable = template.scenario_list
    },
    CB_CPY_TEMP (state) {
      state.copyScenarioTable = JSON.parse(JSON.stringify(state.scenarioTable))
    },
    CB_STR_ITEM_GET (state, data) {
      state.stores = data
    },
    CB_STR_ITEM_EDI (state, data) {
      chatbot.updateChatBotStoreItem(data)
        .then((d) => {
          state.stores = d.data
          alert('変更しました。')
        })
        .catch((e) => {
          alert('エラーが発生いたしました。')
        })
    },
    CB_STR_ITEM_DEL (state, {chatbotID}) {
      for (var idx in state.chatbots) {
        if (state.chatbots[idx].bot_id === chatbotID) {
          state.chatbots.splice(idx, 1)
        }
      }
      alert('削除しました。')
      for (var idd in state.stores) {
        if (state.stores[idd].bot_id === chatbotID) {
          state.stores.splice(idd, 1)
        }
      }
    },
    CB_STR_ITEM_INSTL (state, data) {
      state.isInstall = true
      chatbot.installChatBot(data)
        .then((d) => {
          state.isInstall = false
          alert('インストールが完了しました。')
        })
        .catch((e) => {
          alert('エラーが発生いたしました。')
        })
    },
    CB_STR_HIST_CRE (state, data) {
      chatbot.createChatBotStoreHistory(data)
        .then((d) => {
          state.installHistory.push(d.data)
        })
        .catch((e) => {
          alert('エラーが発生いたしました。')
        })
    },
    CB_STR_RATE_CRE (state, data) {
      chatbot.createChatBotStoreRate(data)
        .then((d) => {
          alert('評価ありがとうございました。')
          state.rateHistory.push(d.data)
        })
        .catch((e) => {
          alert('エラーが発生いたしました。')
        })
    },
    CB_STR_RATE_EDI (state, data) {
      chatbot.editChatBotStoreRate(data)
        .then((d) => {
          alert('評価ありがとうございました。')
        })
        .catch((e) => {
          alert('エラーが発生いたしました。')
        })
    },
    CB_STR_HIST_GET (state) {
      chatbot.getChatBotStoreHistory()
        .then((d) => {
          state.installHistory = d.data
        })
        .catch((e) => {
          alert('エラーが発生いたしました。')
        })
    },
    CB_STR_RATE_GET (state) {
      chatbot.getChatBotStoreRate()
        .then((d) => {
          state.rateHistory = d.data
        })
        .catch((e) => {
          alert('エラーが発生いたしました。')
        })
    },
    CB_SCN_SEND (state, data) {
      chatbot.sendEmailScenario(data)
    },
    CB_CHG_SCN (state, scenario) {
      for (var i in state.scenarioTable) if (state.scenarioTable[i].beforenode == scenario.beforenode) state.scenarioTable[i] = scenario
    },
    GET_SCN_KPI (state, name) {
      this.isLoadingScenarioKPI = true
      chatbot.getScenarioKPI(name)
        .then((d) => {
          state.scenarioKPI = d.data
          this.isLoadingScenarioKPI = false
        })
        .catch((e) => {
          this.isLoadingScenarioKPI = false
        })
    },
    DETAIL (state, {msg, isUp}) {
      state.detail     = msg
      state.detailIsUp = isUp
    },
    CB_EXPORT (state, {company_id, id}) {
      chatbot.exportBot(company_id, id)
    },
    CB_IMPORT (state, file) {
      this.isLoadingImportBot = true
      chatbot.importBot(file)
        .then((d) => {
          this.isLoadingImportBot = false
          state.chatbots.push(d.data)
          alert('作成が完了しました。インポートしたロボのシナリオ編集画面へ遷移します。')
          location.href = '/dashboard/chatbot?view=scenario&scenario=' + d.data.scenario_name
        })
        .catch((e) => {
          alert('インポート中にエラーが発生いたしました。')
          this.isLoadingImportBot = false
        })
    },
    CB_SEND_RMD (state, {id, param}) {
      chatbot.sendReminderEmail(id, param)
    },
    SET_BP_INFO_FLG(state, param){
      state.bluePrintInfoFlg = param
    },
    SET_BP_INFO (state, {width,height,scrollX,scrollY}){
      state.bluePrintInfo.width = width
      state.bluePrintInfo.height = height
      state.bluePrintInfo.scrollX = scrollX
      state.bluePrintInfo.scrollY = scrollY
    },
    UL_MOVIE_FILE (state, {scenario, data, template_id}){
      chatbot.uploadMovieFile(scenario, data, template_id)
        .then((d) => {
          for (var idx in state.scenarioTable) {
            if (state.scenarioTable[idx].beforenode === scenario.beforenode) {
              var setScenario = scenario
              setScenario.movie = d.data.movie
              setScenario.movie_ref = d.data.movie_ref
              state.scenarioTable.splice(idx, 1, setScenario)
            }
          }
        })
        .catch((e) => {
          alert('エラーが発生いたしました。')
        })
    },
    UL_DL_FILE (state, {scenario_pk, data}) {
      chatbot.uploadAttachmentFile(scenario_pk, data)
        .then((d) => {
          for (let idx in state.scenarioTable) {
            if (state.scenarioTable[idx].pk === scenario_pk) {
              state.scenarioTable[idx].parameter.attached_files = d.data.attached_files
              state.scenarioTable.splice(idx, 1, state.scenarioTable[idx])
            }
          }
        })
        .catch((e) => {
          alert('エラーが発生いたしました。')
        })
    },
    ST_GET (state, data) {
      state.stories = data
      state.stories.sort((a, b) => {
        return a.story_order - b.story_order
      })
      state.isStoryLoading = false
    },
    ST_PUB_GET (state, data) {
      state.story = JSON.parse(data.story)
      state.scenes = JSON.parse(data.scenes)
      state.characters = JSON.parse(data.characters)
      state.storyDialog = JSON.parse(data.story_dialog)
      state.otherStories = JSON.parse(data.other_story)
      state.isCompletedStory = true
    },
    ST_SET (state, data) {
      state.story = data
    },
    ST_CREATE (state, data) {
      state.story = data
      state.stories.push(data)
      state.storyLists.push(data)
    },
    ST_UPDATE (state, data) {
      state.story = data
      for (let i in state.stories) {
        if (state.stories[i].story_id == data.story_id) state.stories.splice(i, 1, data)
      }
    },
    ST_DELETE (state, id) {
      for (let i in state.stories) {
        if (state.stories[i].story_id == id) state.stories.splice(i, 1)
      }
    },
    ST_SCN_GET (state, data) {
      state.scenes = data
    },
    ST_SCN_CREATE (state, data) {
      state.scenes.push(data)
    },
    ST_SCN_UPDATE (state, data) {
      for (let i in state.scenes) {
        if (state.scenes[i].pk == data.pk) state.scenes.splice(i, 1, data)
      }
    },
    ST_SCN_DELETE (state, id) {
      for (let i in state.scenes) {
        if (state.scenes[i].pk == id) state.scenes.splice(i, 1)
      }
      state.isDelete = !state.isDelete
    },
    ST_CHR_GET (state, data) {
      state.characters = data
    },
    ST_CHR_CREATE (state, data) {
      state.characters.push(data)
    },
    ST_CHR_UPDATE (state, data) {
      for (let i in state.characters) {
        if (state.characters[i].pk == data.pk) state.characters.splice(i, 1, data)
      }
    },
    ST_CHR_DELETE (state, id) {
      for (let i in state.characters) {
        if (state.characters[i].pk == id) state.characters.splice(i, 1)
      }
    },
    ST_DLG_GET (state, data) {
      state.storyDialog = data
    },
    ST_DLG_CREATE (state, data) {
      state.storyDialog.push(data)
    },
    ST_DLG_IDX_CREATE(state, data) {
      state.storyDialog.splice(data.dialog_order, 0, data)
      state.createDialogFlg = !state.createDialogFlg
    },
    ST_DLG_UPDATE (state, data) {
      for (let i in state.storyDialog) {
        if (state.storyDialog[i].pk == data.pk) state.storyDialog.splice(i, 1, data)
      }
    },
    ST_DLG_DELETE (state, id) {
      for (let i in state.storyDialog) {
        if (state.storyDialog[i].pk == id) state.storyDialog.splice(i, 1)
      }
    },
    ST_PUB_NEXT (state, data) {
      state.isGetPubStory = false
      state.nextPubStory.push(data)
    },
    ST_PUB_NEXT_LOADING (state) {
      state.isGetPubStory = true
    },
    ST_LOADING (state, flg) {
      state.isStoryLoading = flg
    },
    ST_SAVING (state, flg) {
      state.isSavingStory = flg
    },
    ST_EXPORTING (state, flg) {
      state.isExportLoading = flg
    },
    ST_COPY (state, {data, idx}) {
      state.stories.splice(idx + 1, 0, data)
    },
    GET_STORY_USER_ACTION(state, data) {
      state.storyUserAction.wantToMeet = []
      state.storyUserAction.finishReading = []
      state.storyUserAction.question = []
      for (let d of data) {
        if (d.action_type == 0) {
          state.storyUserAction.wantToMeet.push(d)
        } else if (d.action_type == 1) {
          state.storyUserAction.finishReading.push(d)
        } else if (d.action_type == 2) {
          state.storyUserAction.question.push(d)
        }
        if (d.unread) {
          state.storyUserAction.unread_zero = d.unread_zero
          state.storyUserAction.unread_one = d.unread_one
          state.storyUserAction.unread_two = d.unread_two
        }
      }
    },
    GET_STORY_PROFILE_FAVORITE (state, data) {
      state.storyProfileFavorite = data
    },
    SET_QUIZ_ANSWER (state, data) {
      state.storyQuizAnswers = data.sort((a,b) => {
        return new Date(b.created_at).getTime() - new Date(a.created_at).getTime()
      })
    },
    CLICK_AUTO_BTN (state, payload) {
      state.isAutomatic = payload
    },
    MOUNT_CHATPAGE(state) {
      state.talkEnd = false
    },
    CLEAR_STORY(state) {
      state.story = []
      state.scenes = []
      state.characters = []
      state.storyDialog = []
    },
    CLEAR_STORY_DIALOG(state) {
      state.storyDialog = []
    },
    IS_CLICK_TAG (state, {flg,id,tagList}) {
      state.searchWordsBox = []
      state.searchWordsBox = tagList
      state.isClickTag=flg
      state.isClickId=id
    },
    SEARCH_WORDS_INITIAL (state, {tag, tagList}) {
      state.searchWordsBox = []
      function searchLanguage (str) {
          const eng = new RegExp(/^[a-zA-Z]*$/);
          const jap = new RegExp(/^[ぁ-んー]*$/);
          if (eng.test(str)) {
            return "english"
          } else if (jap.test(str)) {
            return "japanese"
          } else {
            return "noLanguage"
          }
      }
      let tagBox = []
      let tagBox2 = []
      if (searchLanguage(tag) == "english") {
        for (let i in tagList) {
          tagBox.push([tagList[i][2].indexOf(tag), i])
        }
      } else if (searchLanguage(tag) == "japanese") {
        for(let i in tagList){
          tagBox.push([tagList[i][1].indexOf(tag), i])
        }
      } else {
        for (let i in tagList){
          tagBox.push([tagList[i][0].indexOf(tag), i])
        }
      }

      for (let i in tagBox) {
        if (tagBox[i][0] != -1) {
        tagBox2.push(tagBox[i])
        }
      }

      tagBox2.sort(function (a, b) {
        return (a[0] - b[0])
      })

      for (let i in tagBox2) {
        state.searchWordsBox.push(tagList[tagBox2[i][1]])
      }
    },
    // ChatBotMini API
    CB_MN_CREATE (state, data) {
      for (let i in state.chatbots) {
        if (state.chatbots[i].bot_id === data.chatbot) {
          state.chatbots[i].chatbot_mini.push(data)
        }
      }
    },
    CB_MN_GET (state, data) {
      state.chatbotminis = data
    },
    CB_MN_SET (state, data) {
      state.isStartBotSet += 1
      chatbot.updateChatBotMini(data)
        .then((d) => {
          for (let i in state.chatbots) {
            if (state.chatbots[i].bot_id === d.chatbot) {
              for (let j in state.chatbots[i].chatbot_mini) {
                if (state.chatbots[i].chatbot_mini[j].pk === d.pk) {
                  state.chatbots[i].chatbot_mini.splice(j, 1, d)
                }
              }
            }
          }
          state.isStartBotSet -= 1
        })
        .catch((e) => {
          state.isStartBotSet -= 1
        })
    },
    CB_MN_UPDATE (state, data) {
      state.isStartBotSet += 1
      for (let i in state.chatbots) {
        if (state.chatbots[i].bot_id === data.chatbot) {
          for (let j in state.chatbots[i].chatbot_mini) {
            if (state.chatbots[i].chatbot_mini[j].pk === data.pk) {
              state.chatbots[i].chatbot_mini.splice(j, 1, data)
            }
          }
        }
      }
      state.isStartBotSet -= 1
    },
    CB_MN_DELETE (state, id) {
      for (let i in state.chatbots) {
        for (let j in state.chatbots[i].chatbot_mini) {
          if (state.chatbots[i].chatbot_mini[j].pk === id) {
            state.chatbots[i].chatbot_mini.splice(j, 1)
          }
        }
      }
    },
    // ChatBotMiniVariableGroup API
    CB_MNVG_CREATE (state, data) {
      for (let i in state.chatbots) {
        for (let j in state.chatbots[i].chatbot_mini) {
          if (state.chatbots[i].chatbot_mini[j].bot_id === data.chatbotmini) {
            state.chatbots[i].chatbot_mini[j].chatbot_mini_var.push(data)
          }
        }
      }
    },
    CB_MNVGGET (state, data) {
      state.chatbotminivars = data
    },
    CB_MNVG_UPDATE (state, data) {
      for (let i in state.chatbots) {
        for (let j in state.chatbots[i].chatbot_mini) {
          for (let k in state.chatbots[i].chatbot_mini[j].chatbot_mini_var) {
            if (state.chatbots[i].chatbot_mini[j].chatbot_mini_var[k].pk === data.pk) {
              state.chatbots[i].chatbot_mini[j].chatbot_mini_var.splice(k, 1, data)
            }
          }
        }
      }
    },
    CB_MNVG_DELETE (state, id) {
      for (let i in state.chatbots) {
        for (let j in state.chatbots[i].chatbot_mini) {
          for (let k in state.chatbots[i].chatbot_mini[j].chatbot_mini_var) {
            if (state.chatbots[i].chatbot_mini[j].chatbot_mini_var[k].pk === id) {
              state.chatbots[i].chatbot_mini[j].chatbot_mini_var.splice(k, 1)
            }
          }
        }
      }
    },
    SET_SCENARIO_TITLE_BEFORE_CHANGE (state, payload) {
      state.scenarioTitleBeforeChange = payload
    },
    GET_EDIT_AREA_RATIO (state) {
      if (state.scenarioTable) {
        // シナリオパーツの最大座標を探す
        let maxX = 0
        let maxY = 0
        for (let scenario of state.scenarioTable) {
          // 座標の大きい方を残していく
          maxX = (maxX < scenario.beforenodeX) ? scenario.beforenodeX : maxX
          maxY = (maxY < scenario.beforenodeY) ? scenario.beforenodeY : maxY
        }
        // ノードのペジェ曲線分があるので10%割増し
        maxY = Math.floor(maxY * 1.1)
        // デフォルトの幅5000、高さ4000に対する倍率を求める
        const ratioX = Math.round((maxX / 5000) * 10) / 10
        const ratioY = Math.round((maxY / 4000) * 10) / 10
        if (ratioX > 1 || ratioY > 1) {
          // XとYどちらかの座標がはみ出るなら倍率を格納
          state.editAreaRatio = (ratioX > ratioY) ? ratioX : ratioY
        } else {
          // 座標がはみ出なければ1倍
          state.editAreaRatio = 1
        }
      } else {
        state.editAreaRatio = 1
      }
    },
    CB_HIS_CREATE (state, data) {
      state.chatbotHistory.unshift(data)
    },
    CB_HIS_GET (state, data) {
      state.chatbotHistory = data
    },
    SCN_HIS_GET (state, data) {
      state.scenarioHistory = data
    },
    CBUT_HIS_GET (state, data) {
      state.chatbotUsedTimeHistory = data
    },
    CREATE_SCN_HIS (state, data) {
      state.scenarioHistoryAny = data
    },
    // ChatBotTag API
    CB_TAG_CREATE (state, data) {
      state.chatbottags.push(data)
    },
    CB_TAG_GET (state, data) {
      state.chatbottags = data
    },
    CB_TAG_UPDATE (state, data) {
      for (let i in state.chatbottags) {
        if (state.chatbottags[i].pk === data.pk) {
          state.chatbottags.splice(i, 1, data)
          break
        }
      }
    },
    CB_TAG_DELETE (state, id) {
      for (let i in state.chatbottags) {
        if (state.chatbottags[i].pk === id) {
          state.chatbottags.splice(i, 1)
          return
        }
      }
    },
    DRAG_SCROLL (state, flg) {
      state.isDragScroll = flg
    },
    OPEN_CHATBOT_DETAIL (state, flg) {
      state.isModalChatBotDetail = flg
    },
    SET_LAST_VIEW (state, value) {
      state.lastView = value
    },
    IMPORT_CMVG (state, data) {
      // bot_idからbotデータを参照できるように変換
      let bot_map = {}
      for (let bot of data) {
        bot_map[bot.bot_id] = bot
      }
      // state.chatbotsを更新
      for (let i in state.chatbots) {
        if (bot_map[state.chatbots[i].bot_id]) {
          state.chatbots[i].chatbot_mini = bot_map[state.chatbots[i].bot_id].chatbot_mini
        }
      }
      state.chatbots.sort((a, b) => {
        return a.order_num - b.order_num
      })
    },
    REAL_SET_SCENARIO (state, data) {
      // 一件だけ入れ替えたいのでこれで
      let index = _.findIndex(state.scenarioTable, (obj) => {return obj.pk === data.pk})
      if (index > -1) {
        data.beforenodeX = state.scenarioTable[index].beforenodeX
        data.beforenodeY = state.scenarioTable[index].beforenodeY
        state.scenarioTable.splice(index, 1, data)
      }
    },
    REAL_CREATE_SCENARIO (state, data) {
      if (state.selectScenarioName) {
        if (state.selectScenarioName === data.name) {
          let index = _.findIndex(state.scenarioTable, (obj) => {return obj.pk === data.pk})
          if (index === -1) {
            state.scenarioTable.push(data)
          }
        }
      }
    },
    REAL_DELETE_SCENARIO (state, data) {
      // 一件だけ入れ替えたいのでこれで
      if (state.selectScenarioName) {
        if (state.selectScenarioName === data.name) {
          let index = _.findIndex(state.scenarioTable, (obj) => {return obj.pk === data.pk})
          if (index > -1) {
            state.scenarioTable.splice(index, 1)
          }
        }
      }
    },
    SET_IS_CHANGE_NAME (state, flg) {
      state.isChangeName = flg
    },
    CONFIRM_BY_PARTS (state, data) {
      state.isConfirmByParts = true
      var data2 = data.sort(function(a,b){
        if(a.status < b.status) return -1;
        if(a.status > b.status) return 1;
        return 0;
      });
      state.scenarioTable = data2
      state.modalScenario = data2[0]
    },
    CONFIRM_BY_STORIES (state, data) {
      state.isConfirmByStories = true
      state.scenarioTable = data
      for (var s of state.scenarioTable) {
        if (s.start_flg) {
          state.modalScenario = s
          return
        }
      }
      state.modalScenario = []
    },
    RESTORE_PARTS (state) {
      let index = state.scenarioTable.findIndex((scenario) => scenario.beforenode == state.modalScenario.beforenode)
      state.modalScenario = state.scenarioTable[index]
    },
    CHANGE_PARTS_TYPE_PREV (state) {
      var count = -1
      var typeCount = -1
      var prevScenario = -1
      var scenarioTableReverse = []
      for (var s of state.scenarioTable) {
        scenarioTableReverse.unshift(s)
      }
      for (var s in scenarioTableReverse) {
        if (scenarioTableReverse[s].beforenode == state.modalScenario.beforenode) {
          count = Number(s)
        }
        if (count != -1) {
          if (scenarioTableReverse[s].status != state.modalScenario.status) {
            prevScenario = scenarioTableReverse[s].status
            break
          }
        } 
      }
      for (var s in state.scenarioTable) {
        if (state.scenarioTable[s].status == prevScenario) {
          typeCount = Number(s)
          break
        }
      }
      state.modalScenario = state.scenarioTable[typeCount]
    },
    CHANGE_PARTS_PREV (state) {
      var count = -1
      var scenarioTableReverse = []
      for (var s of state.scenarioTable) {
        scenarioTableReverse.unshift(s)
      }
      for (var s in scenarioTableReverse) {
        if (scenarioTableReverse[s].beforenode == state.modalScenario.beforenode) {
          count = Number(s)
        }
      }
      state.modalScenario = scenarioTableReverse[count+1]
    },

    CHANGE_PARTS_NEXT (state) {
      var count = -1
      for (var s in state.scenarioTable) {
        if (state.scenarioTable[s].beforenode == state.modalScenario.beforenode) {
          count = Number(s)
        }
      }
      state.modalScenario = state.scenarioTable[count+1]
    },
    CHANGE_PARTS_TYPE_NEXT (state) {
      var count = -1
      var typeCount = -1
      for (var s in state.scenarioTable) {
        if (state.scenarioTable[s].beforenode == state.modalScenario.beforenode) {
          count = Number(s)
        }
        if (count != -1) {
          if (state.scenarioTable[s].status != state.modalScenario.status) {
            typeCount = Number(s)
            break
          }
        } 
      }
      state.modalScenario = state.scenarioTable[typeCount]
    },
    CHANGE_STORY_PARTS (state, data) {
      for (var s of state.scenarioTable) {
        if (s.beforenode == data) {
          state.modalScenario = s
          break
        }
      }
    },
    GET_ALL_STORY (state, data) {
      state.scenarioTable = data

      function getNextNode(s, next) {
        for (var i of pair) {
          if (i[0] == next) {
            let nextList = startScenarioList[s].slice()
            if (nextList.includes(i[1])) {
              nextList.push("")
              startScenarioList.push(nextList)
            } else {
              nextList.push(i[1])
              startScenarioList.push(nextList)
              getNextNode(startScenarioList.length - 1, i[1])
            }
          }
        }
      }

      // シナリオの前後のリストを作成
      var pair = []
      for (var s of state.scenarioTable) {
        for (var select of s.select) {
          var select_list = [s.beforenode, select.next_node]
          pair.push(select_list)
        }
      }

      // 開始シナリオを取得
      var startNode = ""
      for (var s of state.scenarioTable) {
        if (s.start_flg) {
          startNode = s.beforenode
          break
        }
      }

      // 開始シナリオと次のシナリオのペアのリストを作成
      var startScenarioList = []
      for (var i of pair) {
        if (i[0] == startNode) {
          startScenarioList.push(i)
        }
      }

      // すべてのストーリーを取得
      var doubleList = []
      for (var i of pair) {
        for (var s in startScenarioList) {
          if (startScenarioList[s][1] == i[0]) {      
            if (doubleList.includes(i[0])) {
              var scList = []
              scList.push(startScenarioList[s][0])
              scList.push(i[0])
              if (scList.includes(i[1])) {
                scList.push("")
                startScenarioList.push(scList)
              } else {
                scList.push(i[1])
                startScenarioList.push(scList)
                getNextNode(startScenarioList.length - 1, i[1])
              }
            } else {
              doubleList.push(i[0])
              if (startScenarioList[s].includes(i[1])) {
                startScenarioList[s].push("")
              } else {
                startScenarioList[s].push(i[1])
                getNextNode(s, i[1])
              }
            }
          }
        }
      }

      // 最後までたどりついたストーリーのみ残す
      var answer = []
      for (var s of startScenarioList) {
        if (s[s.length-1] == "") {
          answer.push(s)
        }
      }

      // 重複しているストーリーの削除
      var li1 = []
      for (var a of answer) {
        var str = a.join(',');
        li1.push(str)
      }
      var li2 = Array.from(new Set(li1))
      var storyList = []
      for (var l of li2) {
        var ary = l.split(',');
        storyList.push(ary)
      }
      state.allStory = storyList.sort()
      for (var s of state.scenarioTable) {
        if (s.start_flg) {
          if (s.story_confirm) {
            state.storyConfirm = s.story_confirm.split(',');
          }
          break
        }
      }
    },
    ALL_STORY_SET (state) {

      function getNextNode(s, next) {
        for (var i of pair) {
          if (i[0] == next) {
            let nextList = startScenarioList[s].slice()
            if (nextList.includes(i[1])) {
              nextList.push("")
              startScenarioList.push(nextList)
            } else {
              nextList.push(i[1])
              startScenarioList.push(nextList)
              getNextNode(startScenarioList.length - 1, i[1])
            }
          }
        }
      }

      // シナリオの前後のリストを作成
      var pair = []
      for (var s of state.scenarioTable) {
        for (var select of s.select) {
          var select_list = [s.beforenode, select.next_node]
          pair.push(select_list)
        }
      }

      // 開始シナリオを取得
      var startNode = ""
      for (var s of state.scenarioTable) {
        if (s.start_flg) {
          startNode = s.beforenode
          break
        }
      }

      // 開始シナリオと次のシナリオのペアのリストを作成
      var startScenarioList = []
      for (var i of pair) {
        if (i[0] == startNode) {
          startScenarioList.push(i)
        }
      }

      // すべてのストーリーを取得
      var doubleList = []
      for (var i of pair) {
        for (var s in startScenarioList) {
          if (startScenarioList[s][1] == i[0]) {      
            if (doubleList.includes(i[0])) {
              var scList = []
              scList.push(startScenarioList[s][0])
              scList.push(i[0])
              if (scList.includes(i[1])) {
                scList.push("")
                startScenarioList.push(scList)
              } else {
                scList.push(i[1])
                startScenarioList.push(scList)
                getNextNode(startScenarioList.length - 1, i[1])
              }
            } else {
              doubleList.push(i[0])
              if (startScenarioList[s].includes(i[1])) {
                startScenarioList[s].push("")
              } else {
                startScenarioList[s].push(i[1])
                getNextNode(s, i[1])
              }
            }
          }
        }
      }

      // 最後までたどりついたストーリーのみ残す
      var answer = []
      for (var s of startScenarioList) {
        if (s[s.length-1] == "") {
          answer.push(s)
        }
      }

      // 重複しているストーリーの削除  
      var li1 = []
      for (var a of answer) {
        var str = a.join(',');
        li1.push(str)
      }
      var li2 = Array.from(new Set(li1))
      var storyList = []
      for (var l of li2) {
        var ary = l.split(',');
        storyList.push(ary)
      }
      state.allStory = storyList.sort()

      chatbot.UpdateScenarioStory(startNode, state.allStory.length)
    },
    UPDATE_CONFIRM_STORY (state) {
      for (var s of state.scenarioTable) {
        if (s.start_flg) {
          state.modalScenario = s
          return
        }
      }
    },
    CB_TEMP_GET (state, data) {
      state.isCBLoading = false
      if (data.length > 0) {
        state.templateRobo = data
      }
    },
    SET_SCENARIO_TABLE (state, newRoboData) {
      state.chatbots.push(newRoboData.robo)
      state.selectChatbot = newRoboData.robo
      state.scenarioTable = newRoboData.scenario
    },
    DEL_SCENARIO_TABLE (state, scenario_name) {
      for (var idx in state.chatbots) {
        if (state.chatbots[idx].scenario_name === scenario_name) {
          state.chatbots.splice(idx, 1)
        }
      }
      state.selectChatbot = {}
      state.scenarioTable = []
    },
    PLD_EXPORT (state, {scenario_name,scenario_pk}) {
      chatbot.exportPulldown(scenario_name,scenario_pk)
    },
  }
}


// WEBPACK FOOTER //
// ./src/store/modules/chatbot.js